<template>
  <div v-if="hasLoad">
    <el-container>
      <el-aside :width="aliasWidth">
        {{pageInfo.pageName}}
        <span v-if="pcH5Type" style="background:red;">PC和H5设置已经区分!!!!!!!</span>
        <el-form ref="pageForm" style="background-color: white;" label-width="160px" label-suffix=":">
          <!--PC页面结构设置分块-->
          <el-row>
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              PC页面横向分块:
            </el-col>
            <el-row  type="flex" style="flex-wrap:wrap;" >
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-button type="primary" title="pageBoxStyleSet" @click="openDialog(26)">页面BOX样式设置</el-button>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="背景颜色" prop="bgColor">
                  <el-input type="text" v-model="pageInfo.styleSet.bgColor" placeholder="#ffffff"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="查看内容屏幕占比lg" prop="rotationChartScreenLg">
                  <el-input type="text" v-model="pageInfo.styleSet.rotationChartScreenLg" placeholder="最大24"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="查看内容屏幕占比xl" prop="rotationChartScreenXl">
                  <el-input type="text" v-model="pageInfo.styleSet.rotationChartScreenXl" placeholder="最大24"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-input type="text" v-model="colBlockNum" placeholder="1" @input="setColValue"><template slot="prepend">块数:</template></el-input>
                  </el-col>
                  <el-col v-if="colProportion" :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="(item,index) in pageInfo.styleSet.setBlockingPC" :key="'col'+index">
                    <el-input type="text" v-model="pageInfo.styleSet.setBlockingPC[index].width" :placeholder="'第'+(index+1)+'块width'" ><template slot="prepend">第{{index+1}}块宽</template></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-row>
          <!-- 列表页面的 头图设置 -->
          <el-row v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              列表头图设置:
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-select
                v-model="pageInfo.listStyleSet.listBgImageStyle" clearable
                :multiple="false"
              >
                <el-option v-for="(one,index) in ImageList" v-if="one.TYPE==1" :key="'image_'+index"
                    :label="one.NAME" :value="one.BG_URL"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <el-form-item label="点击事件" prop="clickType">
                <el-select
                  v-model="pageInfo.listStyleSet.imageClickType" clearable
                  :multiple="false"
                >
                  <el-option label="跳转列表页" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <el-button title="listBgImageCommonStyleSet" @click="openDialog(25)" >列表头图样式设置</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <el-form-item label="点击跳转" >
                <el-input placeholder="跳转的对象ID" v-model="pageInfo.listStyleSet.imageClickTableId">
                  <template slot="prepend">tableId:</template>
                </el-input> 
                <el-input placeholder="跳转的PageID" v-model="pageInfo.listStyleSet.imageClickPageId">
                  <template slot="prepend">pageId:</template>
                </el-input> 
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 列表页面的 搜索条件设置 -->
          <el-row v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              搜索条件设置:
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-button title="searchStyleSet" @click="openDialog(1)" >设置</el-button>
              <!-- <el-button title="searchCommonStyleSet" @click="openDialog(14)" >样式设置</el-button> -->
            </el-col>
          </el-row>
          <!-- 列表页面搜索条件的字段设置 -->
          <el-row v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
              搜索条件字段设置:
              <el-button type="primary" icon="el-icon-plus" circle @click="addSearchField"></el-button>
              <el-button type="primary" size="mini" @click="deleteAllSearchField">清除所有搜索</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="21" :lg="21" :xl="21">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
                  v-for="(oneField,index) in pageInfo.searchSet" :key="'field_'+index"
                >
                  {{oneField.lgName}}
                  <el-button-group style="">
                    <el-button type="primary" size="mini" title="searchSet" icon="el-icon-s-tools" circle @click="openDialog(33,index)"></el-button>
                    <el-button type="primary" size="mini" title="searchSet" icon="el-icon-edit" circle @click="openDialog(6,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.searchSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" style="padding: 7px;" @click="toDownChildOne(pageInfo.searchSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.searchSet,index)"></el-button>
                  </el-button-group>
                  
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
                  v-for="(oneField,index) in pageInfo.dynamicSearchSet" :key="'field_'+index"
                >
                  {{oneField.fieldCnName}}
                  <el-button type="primary" title="dynamicSearchSet" icon="el-icon-edit" circle @click="openDialog(10,index)"></el-button>
                </el-col>
                
              </el-row>
            </el-col>
          </el-row>
          <!-- 列表页面的 展现形式设置 -->
          <el-row v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15 || pageInfo.pageType == 16" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              列表展现形式:
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-button title="listStyleSet" @click="openDialog(4)" >样式设置</el-button>
              <el-button title="listStyleSet" @click="openDialog(29)">列表过滤设置</el-button>
            </el-col>
          </el-row>
          <!-- 列表页面字段展现形式设置 -->
          <el-row v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              列表字段设置:
              <el-button type="primary" icon="el-icon-plus" circle @click="addListField"></el-button>
              <el-button type="primary" size="mini" @click="deleteAllListField">清除所有字段</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
                  v-for="(one,index) in pageInfo.fieldSet" :key="'listField_'+index"
                >
                  {{one.lgName}}
                  <el-button-group style="">
                    <el-button type="primary" size="mini" title="fieldSet" icon="el-icon-s-tools" circle @click="openDialog(30,index)"></el-button>
                    <el-button type="primary" size="mini" title="fieldSet" icon="el-icon-edit" circle @click="openDialog(8,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.fieldSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" circle @click="toDownChildOne(pageInfo.fieldSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.fieldSet,index)"></el-button>
                  </el-button-group>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 列表页面操作按钮设置 -->
          <el-row type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              列表按钮条设置:<el-button type="primary" icon="el-icon-plus" circle @click="addOperaButtonSet(2)"></el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <el-select
                    v-model="pageInfo.listStyleSet.pageButtonLoaction" clearable
                    :multiple="false"
                  >
                      <el-option label="搜索块上部" value="1"></el-option>
                      <el-option label="搜索块下部" value="2"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
                  v-for="(one,index) in pageInfo.buttonSet" :key="'one_'+index"
                >
                  {{one.buttonName}}
                  <el-button-group style="">
                    <el-button type="primary" size="mini" title="buttonSet" icon="el-icon-s-tools" circle @click="openDialog(31,index)"></el-button>
                    <el-button type="primary" size="mini" title="buttonSet" icon="el-icon-edit" circle @click="openDialog(11,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.buttonSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" circle @click="toDownChildOne(pageInfo.buttonSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.buttonSet,index)"></el-button>
                  </el-button-group>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 列表页面数据按钮设置 -->
          <el-row type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              数据按钮设置:<el-button type="primary" icon="el-icon-plus" circle @click="addOperaButtonSet(1)"></el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-button type="primary" title="operaButtonSetAll" @click="openDialog(770)">按钮组整体样式设置</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
                  v-for="(one,index) in pageInfo.operaButtonSet" :key="'one_'+index"
                >
                  {{one.buttonName}}
                  <el-button-group style="">
                    <el-button type="primary" size="mini" title="operaButtonSet" icon="el-icon-s-tools" circle @click="openDialog(32,index)"></el-button>
                    <el-button type="primary" size="mini" title="operaButtonSet" icon="el-icon-edit" circle @click="openDialog(7,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.operaButtonSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" circle @click="toDownChildOne(pageInfo.operaButtonSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.operaButtonSet,index)"></el-button>
                  </el-button-group>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 添加修改页面的字段设置 -->
          <LookFieldSet v-model="pageInfo" v-if="pageInfo.pageType == 5||pageInfo.pageType == 7||pageInfo.pageType == 11" :ImageList="ImageList"></LookFieldSet>
          <!-- <el-row v-if="pageInfo.pageType == 5||pageInfo.pageType == 7||pageInfo.pageType == 11" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              字段设置:
              <div>
                行:<el-input-number v-model="fieldTableInfo.row" size="mini" style="width: 100px;" placeholder="3" controls-position="right" ></el-input-number>
              </div>
              <div>
                列:<el-input-number v-model="fieldTableInfo.col" size="mini" style="width: 100px;" placeholder="3" controls-position="right" ></el-input-number>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <table style="-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;user-select:none;">
                <tr v-for="xhRow in (fieldTableInfo.row)" :key="'row_'+xhRow">
                  <template v-for="xhCol in (fieldTableInfo.col)">
                    <td  :key="'row_'+xhRow+'_' + xhCol" style="width:300px;height:32px;border: 1px solid #d2d9e9;" rowspan="1" :colspan="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']" class="dragger_td" :row="xhRow" :col="xhCol">
                      <template v-for="(oneField,index) in pageInfo.addFieldSet">
                        <div v-if="oneField.row==(xhRow-1) && (oneField.col>=(xhCol-1) && oneField.col<=(xhCol-1)+(fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']?(fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']-1):0)) " :key="'field_'+index" class="dragger_field" style="display: inline-block;border:1px solid;height:32px;" >
                          <span @mousedown="e=>addFieldMove(e,oneField)">{{oneField.fieldCnName}}</span>
                          <el-button-group style="">
                            <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-s-tools" circle @click="openDialog(15,index)"></el-button>
                            <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-edit" circle @click="openDialog(2,index)"></el-button>
                            <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.addFieldSet,index)"></el-button>
                            
                          </el-button-group>
                        </div>
                      </template>
                      <el-button type="primary" size="mini" style="float:right;" icon="el-icon-s-tools" @click="changRowColSpanType(xhRow,xhCol)" ></el-button>
                      <div v-if="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_type']">
                        <el-input type="text" v-model="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']" placeholder="3" @change="colspanChange(xhRow,xhCol)" ><template slot="prepend">列合并</template></el-input>
                      </div>
                    </td>
                  </template>
                </tr>
              </table>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-button type="primary" @click="openDialog(27)">查看页面整体EL_ROW样式设置</el-button>
                    <el-button type="primary" title="lookCommonStyleSet" @click="openDialog(13)">查看页面整体样式设置</el-button>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    展示类型:
                      <el-select
                              v-model="pageInfo.styleSet.fieldStyle" clearable
                              :multiple="false"
                      >
                          <el-option label="默认" value="1"></el-option>
                          <el-option label="展示信息card" value="2"></el-option>
                      </el-select>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                      全局记录主键:
                      <el-select
                              v-model="pageInfo.styleSet.ifGlobalId" clearable
                              :multiple="false"
                      >
                          <el-option label="是" value="1"></el-option>
                          <el-option label="否" value="2"></el-option>
                      </el-select>
                  </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                  v-for="(oneField,index) in pageInfo.addFieldSet" :key="'field_'+index"
                >
                  <span style="display: inline-block;min-width: 100px">{{oneField.fieldCnName}}:</span>
                  <el-button-group style="">
                    <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-s-tools" circle @click="openDialog(15,index)"></el-button>
                    <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-edit" circle @click="openDialog(2,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.addFieldSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" style="padding: 7px;" @click="toDownChildOne(pageInfo.addFieldSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.addFieldSet,index)"></el-button>
                  </el-button-group>
                  <el-button v-if="oneField.showFieldArr > 0" type="primary" @click="openDialog(12,index)">打开子页面</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row> -->
          <!-- 进行关联选项卡设置 -->
          <el-row v-if="pageInfo.pageType == 5||pageInfo.pageType == 7||pageInfo.pageType == 11" type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              选项卡设置:
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  展现形式:
                  <el-select
                    v-model="pageInfo.styleSet.tabStyle" clearable
                    :multiple="false"
                  >
                    <el-option label="默认平铺" value="1"></el-option>
                    <el-option label="选项卡" value="2"></el-option>
                    <el-option label="左右" value="3"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-form-item label="特殊tab分块" prop="specialTabDistinguish">
                    <el-select
                            v-model="pageInfo.styleSet.specialTabDistinguish" clearable
                            :multiple="false"
                    >
                      <el-option label="左右分" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-form-item label="自定义标题名称" >
                    <el-input placeholder="标题" v-model="pageInfo.styleSet.titleHide">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-button type="primary" title="lookTileTabsCommonStyleSet"  @click="openDialog(16)">平铺选项卡样式</el-button>
                  <el-button type="primary" title="lookTabTitleCommonStyleSet"  @click="openDialog(17)">选项卡名称样式</el-button>
                  <el-button type="primary" title="lookTabMoreCommonStyleSet"  @click="openDialog(18)">选项卡更多标头样式</el-button>
                  <el-button type="primary" title="lookTabsBoxCommonStyleSet"  @click="openDialog(19)">选项卡整体样式设置</el-button>
                  <el-button type="primary" title="lookTabsCommonStyleSet"  @click="openDialog(20)">选项卡tabs组件样式设置</el-button>
                  <el-button type="primary" title="lookTabCommonStyleSet"  @click="openDialog(28)">选项卡tab组件样式设置</el-button>
                  <el-button type="primary" title="lookTabDefaultCommonStyleSet"  @click="openDialog(21)">选项卡tab未选中样式设置</el-button>
                  <el-button type="primary" title="lookTabCheckCommonStyleSet"  @click="openDialog(22)">选项卡tab选中样式设置</el-button>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-form-item label="是否显示记录数" >
                    <el-select
                      v-model="pageInfo.styleSet.ifShowTotal" clearable
                      :multiple="false"
                      placeholder="是否显示记录数"
                    >
                      <el-option label="显示" value="1"></el-option>
                      <el-option label="不显示" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-form-item label="记录数为0是否隐藏">
                    <el-select
                      v-model="pageInfo.styleSet.ifHideCount" clearable
                      :multiple="false"
                      placeholder="记录数为0是否隐藏"
                    >
                      <el-option label="隐藏" value="1"></el-option>
                      <el-option label="显示" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              选项卡页面设置:<el-button type="primary" icon="el-icon-plus" circle @click="addTabPageSet(1)"></el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                      v-for="(oneTablePage,index) in pageInfo.tabPageSet" :key="'tabPage_'+index"
              >
                <span style="display: inline-block;min-width: 100px">{{oneTablePage.tabName}}:</span>
                <el-button type="primary" title="tabPageSet" @click="openDialog(36,index)">基础设置</el-button>
                <el-button type="primary" title="tabPageSet" @click="openDialog(3,index)">基础样式设置</el-button>
                <el-button type="primary" title="lookTabChildDefaultCommonStyleSet" @click="openDialog(23,index)">未选中样式设置</el-button>
                <el-button type="primary" title="lookTabChildCheckCommonStyleSet" @click="openDialog(24,index)">选中样式设置</el-button>
                <el-button type="primary" @click="openDialog(5,index)">打开关联页面</el-button>
                <el-button-group style="">
                    <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(pageInfo.tabPageSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-bottom" circle @click="toDownChildOne(pageInfo.tabPageSet,index)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(pageInfo.tabPageSet,index)"></el-button>
                  </el-button-group>

              </el-col>
            </el-row>
            </el-col>
          </el-row>
          <!-- 进行关联选项卡设置 -->
          <el-row v-if="pageInfo.pageType == 5||pageInfo.pageType == 7||pageInfo.pageType == 11"  type="flex" style="flex-wrap:wrap;" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              选项卡样式设置:
            </el-col>
            <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <!--tab选中样式  no-line: 选中无下划线   默认：圆角深色背景环绕选中tab  line: 选中带有深色下划线-->
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-select
                          v-model="pageInfo.styleSet.newTabLine" clearable
                          :multiple="false"
                  >
                    <el-option label="iconBlock" value="iconBlock"></el-option>
                    <el-option label="no-line" value="no-line"></el-option>
                    <el-option label="line" value="line"></el-option>
                    <el-option label="排行榜" value="paihang"></el-option>
                    <el-option label="card类型标签页" value="tabPage"></el-option>
                    <el-option label="block" value="block"></el-option>
                    <el-option label="fillet" value="fillet"></el-option>
                    <el-option label="intervalTab" value="intervalTab"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-select
                    v-model="pageInfo.styleSet.setSticky" clearable
                    :multiple="false"
                  >
                    <el-option label="默认不吸顶" value="1"></el-option>
                    <el-option label="吸顶" value="2"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <!-- 其他设置  追加新的设置使用 -->
          <el-row  type="flex" style="flex-wrap:wrap;" v-if="pageInfo.pageType == 5||pageInfo.pageType == 7||pageInfo.pageType == 11||pageInfo.pageType == 8" >
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              修改按钮设置:
            </el-col>
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <el-button type="primary" title="updateButtonSetAll" @click="openDialog(771)">按钮组整体样式设置</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
                  v-for="(one,index) in pageInfo.styleSet.updateButtonSet" :key="'one_'+index"
                >
                  {{one.buttonName}}
                  <el-button type="primary" title="updateButtonSet" icon="el-icon-edit" circle @click="openDialog(9,index)"></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
                

          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
              <div style="text-align: center;margin-top: 20px">
                <el-button type="success" @click="saveInfo" :loading="fullscreenLoading"
                >
                  保存
                </el-button>
                <el-button type="info" @click="cancelPage" >取消</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-dialog v-if="addDialogFlag" title="设置" :visible.sync="addDialogFlag" width=98% top="1vh" center append-to-body :before-close="handleClose">
              <!-- 搜索条件设置 -->
              <PageBasicSet v-if="addDialogType==1" v-model="pageInfo.searchStyleSet" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="searchSetBlockArr" :cssBlockArr="searchSetCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 添加修改查看页面的 字段设置 -->
              <PageBasicSet v-if="addDialogType==2" v-model="pageInfo.addFieldSet[nowFieldIndex].styleSet" :fieldOne="pageInfo.addFieldSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="pageFieldBlockArr" :cssBlockArr="pageFieldCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 选项卡设置 -->
              <!-- 选项卡基础设置 -->
              <PageBasicSet v-if="addDialogType==36" v-model="pageInfo.tabPageSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId"  :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="tabPageBasicBlockArr" :cssBlockArr="[]" :type="addDialogType"></PageBasicSet>
              <TabPageSet v-if="addDialogType==3" v-model="pageInfo.tabPageSet[nowFieldIndex].styleSet" :ImageList="ImageList"></TabPageSet>
              <!-- 列表页面样式设置 -->
              <PageBasicSet v-if="addDialogType==4" v-model="pageInfo.listStyleSet" :ImageList="ImageList" :tableId="pageInfo.tableId"  :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="listPageBlockArr" :cssBlockArr="listPageCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 搜索条件的字段设置 -->
              <PageBasicSet v-if="addDialogType==6" v-model="pageInfo.searchSet[nowFieldIndex].styleSet" :tableId="pageInfo.tableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :relationTableId="pageInfo.relationTableId" :basicBlockArr="searchFieldBlockArr" :cssBlockArr="searchFieldCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 搜索条件字段基础设置 -->
              <PageBasicSet v-if="addDialogType==33" v-model="pageInfo.searchSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="searchFieldBasicBlockArr" :cssBlockArr="[]" :type="addDialogType"></PageBasicSet>
              <!-- 列表数据按钮设置 -->
              <PageBasicSet v-if="addDialogType==7" v-model="pageInfo.operaButtonSet[nowFieldIndex].styleSet" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="buttonSetBlockArr" :cssBlockArr="buttonSetCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 列表数据按钮按钮基础设置 -->
              <PageBasicSet v-if="addDialogType==32" v-model="pageInfo.operaButtonSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="buttonBasicBlockArr" :cssBlockArr="[]" :type="addDialogType" ></PageBasicSet>
              <!-- 列表字段设置 -->
              <PageBasicSet v-if="addDialogType==8" v-model="pageInfo.fieldSet[nowFieldIndex].styleSet" :ImageList="ImageList" :tableId="pageInfo.tableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :relationTableId="pageInfo.relationTableId" :basicBlockArr="listFieldBlockArr" :cssBlockArr="listFieldCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 列表字段基础设置 -->
              <PageBasicSet v-if="addDialogType==30" v-model="pageInfo.fieldSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :relationTableId="pageInfo.relationTableId" :basicBlockArr="listFieldBasicBlockArr" :cssBlockArr="[]" :type="addDialogType"></PageBasicSet>
              <!-- 添加修改 保存按钮设置 -->
              <PageBasicSet v-if="addDialogType==9" v-model="pageInfo.styleSet.updateButtonSet[nowFieldIndex]" :tableId="pageInfo.tableId"  :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="buttonSetBlockArr" :cssBlockArr="buttonSetCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 动态搜索条件 -->
              <PageBasicSet v-if="addDialogType==10" v-model="pageInfo.dynamicSearchSet[nowFieldIndex].styleSet" :tableId="pageInfo.tableId"  :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="searchFieldBlockArr" :cssBlockArr="searchFieldCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 列表操作(按钮条)按钮设置 -->
              <PageBasicSet v-if="addDialogType==11" v-model="pageInfo.buttonSet[nowFieldIndex].styleSet" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="buttonSetBlockArr" :cssBlockArr="buttonSetCssBlockArr" :type="addDialogType"></PageBasicSet>
              <!-- 按钮基础设置 -->
              <PageBasicSet v-if="addDialogType==31" v-model="pageInfo.buttonSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="buttonBasicBlockArr" :cssBlockArr="[]" :type="addDialogType" ></PageBasicSet>
        
              <!-- 按钮整体样式设置-->
              <CommonStyleSet v-if="addDialogType==770" v-model="pageInfo.styleSet.operaButtonSetAll" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 保存按钮组整体样式设置-->
              <CommonStyleSet v-if="addDialogType==771" v-model="pageInfo.styleSet.updateButtonSetAll" :ImageList="ImageList" ></CommonStyleSet>
              
              <!-- 查看页面整体EL_ROW样式设置-->
              <CommonStyleSet v-if="addDialogType==27" v-model="pageInfo.styleSet.lookCommonRowBoxStyleSet" :ImageType="1" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面整体样式设置-->
              <CommonStyleSet v-if="addDialogType==13" v-model="pageInfo.styleSet.lookCommonStyleSet" :ImageType="1" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 搜索条件样式设置 -->
              <CommonStyleSet v-if="addDialogType==14" v-model="pageInfo.searchStyleSet.searchCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面字段基础设置 -->
              <PageBasicSet v-if="addDialogType==15" v-model="pageInfo.addFieldSet[nowFieldIndex]" :ImageList="ImageList" :tableId="pageInfo.tableId" :relationTableId="pageInfo.relationTableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :basicBlockArr="pageFieldBasicBlockArr" :cssBlockArr="[]" :type="addDialogType"></PageBasicSet>
              <!-- 查看页面 平铺选项卡样式 -->
              <CommonStyleSet v-if="addDialogType==16" v-model="pageInfo.styleSet.lookTileTabsCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡名称样式 -->
              <CommonStyleSet v-if="addDialogType==17" v-model="pageInfo.styleSet.lookTabTitleCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡更多样式 -->
              <CommonStyleSet v-if="addDialogType==18" v-model="pageInfo.styleSet.lookTabMoreCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡整体样式设置 -->
              <CommonStyleSet v-if="addDialogType==19" v-model="pageInfo.styleSet.lookTabsBoxCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡tabs组件样式设置 -->
              <CommonStyleSet v-if="addDialogType==20" v-model="pageInfo.styleSet.lookTabsCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡tab未选中样式设置 -->
              <CommonStyleSet v-if="addDialogType==21" v-model="pageInfo.styleSet.lookTabDefaultCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡tab选中样式设置 -->
              <CommonStyleSet v-if="addDialogType==22" v-model="pageInfo.styleSet.lookTabCheckCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 子选项卡tab未选中样式设置 -->
              <CommonStyleSet v-if="addDialogType==23" v-model="pageInfo.tabPageSet[nowFieldIndex].styleSet.lookTabChildDefaultCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 子选项卡tab选中样式设置 -->
              <CommonStyleSet v-if="addDialogType==24" v-model="pageInfo.tabPageSet[nowFieldIndex].styleSet.lookTabChildCheckCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 头图样式设置 -->
              <CommonStyleSet v-if="addDialogType==25" v-model="pageInfo.listStyleSet.listBgImageCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 页面BOX样式设置 -->
              <CommonStyleSet v-if="addDialogType==26" v-model="pageInfo.styleSet.pageBoxStyleSet" :ImageList="ImageList" ></CommonStyleSet>
              <!-- 查看页面 选项卡tab组件样式设置 -->
              <CommonStyleSet v-if="addDialogType==28" v-model="pageInfo.styleSet.lookTabCommonStyleSet" :ImageList="ImageList" ></CommonStyleSet>

              <!-- 列表过滤设置 -->
              <PageBasicSet v-if="addDialogType==29" v-model="pageInfo" :ImageList="ImageList" :tableId="pageInfo.tableId" :pageId="pageInfo.pageId" :pageName="pageInfo.pageName" :relationTableId="pageInfo.relationTableId" :basicBlockArr="listFilterBasicBlockArr" :cssBlockArr="[]" :type="addDialogType"></PageBasicSet>
              
        </el-dialog>
      </el-aside>
      <el-main :class="sourceType==2?'pcPreviewBox':'h5PreviewBox'">
        <span>预览效果-暂时关闭</span>
        <!-- <kw_list v-if="pageInfo.pageType == 1 || pageInfo.pageType == 15" ref="kw_list_preview" :initPageObj="{tableId:pageInfo.tableId,pageId:pageInfo.pageId}" :isPreview="1" :previewPageSetInfo="pageInfo" :previewPageDataInfo="previewPageDataInfo" :previewVisitSource="sourceType*1" ></kw_list>
        <kw_look v-else-if="pageInfo.pageType == 5 || pageInfo.pageType == 7 || pageInfo.pageType == 11" ref="kw_look_preview" id="kw_look_preview" :pageInfo="pageInfo" :isPreview="1" :previewPageSetInfo="pageInfo" :previewPageDataInfo="previewPageDataInfo" :previewVisitSource="sourceType*1" ></kw_look> -->
      </el-main>
    </el-container>
</div>
</template>

<script>
import $ from 'jquery';
import TabPageSet from '@/components/page/pageSet/TabPageSet.vue';
import PageBasicSet from '@/components/page/pageSet/PageBasicSet.vue';
import CommonStyleSet from '@/components/page/pageSet/CommonStyleSet.vue';
import LookFieldSet from '@/components/page/pageSet/LookFieldSet.vue';
import kw_list from '@/components/list/kw_list.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'PageShowSet',
  props: {
    initPageId: Number
  },
  data() {
    var that = this;
    return {
      //页面ID
      pageId:0,
      //页面对象
      pageInfo:{},
      //当前设置的字段的index
      nowFieldIndex:0,
      //弹出层的打开状态
      addDialogFlag:false,
      addDialogType:0,
      //保存按钮的状态
      fullscreenLoading:false,
      // 图片库的图片
      ImageList:[],
      // 是否加载完成
      hasLoad:false,
      //表格的大小以及合并信息
      fieldTableInfo:{
        row:0,
        col:0,
        now_col:0,
        now_row:0,
        rowColSpanInfo:{

        },
        popoverType:false
      },
      // 1为 小程序(包含H5)   2为PC端设置
      sourceType:1,
//      显示col占比设置
      colProportion:false,
      //col块数
      colBlockNum:1,
      //制作的预览数据
      previewPageDataInfo:null,
      pcH5Type:false,
      aliasWidth:"50%",
      listFieldBlockArr:[{blockCnName:"样式设置",
          fieldArr:[{
            cnName:"样式设置",enName:"cssStyle",type:1,
            dicList:[{label:"默认样式",value:"1"},{label:"默认样式(不显示字段名)",value:"2"},{label:"状态聚合样式",value:"3"},{label:"人员头像列表",value:"4"},{label:"隐藏",value:"5"},{label:"进度条形式",value:"6"},{label:"单行两列",value:"7"},{label:"倒计时",value:"8"},{label:"card下结构",value:"9"},{label:"左上标签",value:"10"},{label:"card上结构",value:"11"},{label:"图片",value:"12"},{label:"聚合显示列",value:"13"},{label:"URL图片",value:"14"},{label:"二维码",value:"15"},{label:"条码",value:"16"},{label:"星级评分",value:"17"},{label:"附件浏览",value:"18"},{label:"富文本显示",value:"19"},{label:"编辑排序",value:"20"},{label:"音频",value:"21"}]
          },{
            cnName:"在card中的位置",enName:"cardPosition",type:1,
            dicList:[{label:"上部",value:"1"},{label:"右侧",value:"2"},{label:"下部",value:"3"},{label:"左侧",value:"4"}]
          },{
            cnName:"在card中的位置2",enName:"cardPosition",type:1,
            dicList:[{label:"上部",value:"1"},{label:"右侧",value:"2"},{label:"下部",value:"3"},{label:"左侧",value:"4"}]
          },{
            cnName:"是否聚合显示字段",enName:"isHavingField",type:1,
            dicList:[{label:"聚合显示",value:"1"},{label:"正常显示",value:"2"}]
          },{
            cnName:"是否显示被购买次数",enName:"isShowLook",type:1,filterName:'cssStyle',filterValue:'3',filterType:1,
            dicList:[{label:"默认显示",value:"0"},{label:"隐藏",value:"1"}]
          },{
            cnName:"表格列是否自动换行",enName:"isLineFeed",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"card时在第几块显示",enName:"isBlockShow",type:2,filterName:'cssStyle',filterValue:'5,6',filterType:2
          },{
            cnName:"card上结构是否一行显示多个",enName:"cardTopShowMore",type:1,filterName:'cssStyle',filterValue:'11',filterType:1,
            dicList:[{label:"默认不显示多个",value:"1"},{label:"显示多个",value:"2"}]
          },{
            cnName:"name图标",enName:"nameBgImage",type:3,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2
          },{
            cnName:"value值图标",enName:"bgImage",type:3,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2
          },{
            cnName:"图标",enName:"iconType",type:2,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2
          },{
            cnName:"是否显示name",enName:"hasname",type:1,filterName:'cssStyle',filterValue:'2,3,4,5,6',filterType:2,
            dicList:[{label:"显示name",value:"1"},{label:"不显示name",value:"2"}]
          },{
            cnName:"显示图标类型",enName:"hasNumIcon",type:1,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2,
            dicList:[{label:"序号",value:"1"},{label:"点赞",value:"2"}]
          },{
            cnName:"是否文本超出显示省略号",enName:"showEllipsis",type:1,filterName:'cssStyle',filterValue:'7',filterType:1,
            dicList:[{label:"显示",value:"1"}]
          },{
            cnName:"位置设置",enName:"pricePosition",type:1,filterName:'cssStyle',filterValue:'5,6',filterType:2,
            dicList:[{label:"默认位置",value:"1"},{label:"右下",value:"2"},{label:"左侧",value:"3"},{label:"右上",value:"4"}]
          },{
            cnName:"原价/现价结构样式",enName:"priceFlexDirection",type:1,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2,
            dicList:[{label:"默认位置上下",value:"column"},{label:"左右",value:"row"}]
          },{
            cnName:"内容是否显示",enName:"textBracketsHide",type:1,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2,
            dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}]
          },{
            cnName:"价格特殊文本拼接",enName:"priceAddText",placeholder:"元",type:2,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2
          },{
            cnName:"价格单位设置",enName:"priceUnit",type:1,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2,
            dicList:[{label:"无",value:""},{label:"￥",value:"￥"},{label:"-",value:"-"},{label:"+",value:"+"}]
          },{
            cnName:"display设置",enName:"isSetInline",type:1,filterName:'cssStyle',filterValue:'3,4,5,6',filterType:2,
            dicList:[{label:"默认不设置",value:"1"},{label:"inline",value:"2"},{label:"flex",value:"3"}]
          },{
            cnName:"表格是否合并行数据",enName:"ifSpanRow",type:1,
            dicList:[{label:"合并",value:"1"},{label:"不合并",value:"2"}]
          },{
            cnName:"进度条形式",enName:"progressType",type:1,filterName:'cssStyle',filterValue:'6',filterType:1,
            dicList:[{label:"线形",value:"line"},{label:"圆形",value:"circle"},{label:"仪表盘",value:"dashboard"}]
          },{
            cnName:"进度条颜色",enName:"progressColor",type:2,filterName:'cssStyle',filterValue:'6',filterType:1
          },{
            cnName:"倒计时定位方式",enName:"timePosition",type:2,filterName:'cssStyle',filterValue:'8',filterType:1
          },{
            cnName:"倒计时left",enName:"timeLeft",type:2,filterName:'cssStyle',filterValue:'8',filterType:1
          },{
            cnName:"倒计时bottom",enName:"timeBottom",type:2,filterName:'cssStyle',filterValue:'8',filterType:1
          },{
            cnName:"图片是否可预览",enName:"imgPreview",type:1,filterName:'cssStyle',filterValue:'4,12',filterType:1,
            dicList:[{label:"不可预览",value:"1"},{label:"可预览",value:"2"},{label:"可预览显示提示",value:"3"}]
          },{
            cnName:"导出样式JS",enName:"exportFieldJs",type:5
          },{
            cnName:"是否自动播放",enName:"ifAutoPlay",type:1,filterName:'cssStyle',filterValue:'21',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"播放结束刷新逻辑",enName:"overRefreshType",type:1,filterName:'cssStyle',filterValue:'21',filterType:1,
            dicList:[{label:"选项卡刷新",value:"1"},{label:"本页刷新",value:"2"}]
          },{
            cnName:"禁用拖动快进",enName:"ifBanFast",type:1,filterName:'cssStyle',filterValue:'21',filterType:1,
            dicList:[{label:"禁用",value:"1"},{label:"不禁用",value:"2"}]
          },{
            cnName:"是否显示封面及音频文本",enName:"ifShowSentences",type:1,filterName:'cssStyle',filterValue:'21',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"是否显示播放进度条",enName:"ifShowSlider",type:1,filterName:'cssStyle',filterValue:'21',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"},{label:"背景音频",value:"3"},{label:"原生组件",value:"4"},{label:"小喇叭",value:"5"}]
          }]
        }
      ],
      listFieldCssBlockArr:[{
        blockCnName:"字段基础设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"字段外层样式设置",enName:"listFieldStyleSet",type:1
        },{
          cnName:"字段name样式设置",enName:"listFieldNameStyleSet",type:1
        },{
          cnName:"字段value样式设置",enName:"listFieldValueStyleSet",type:1
        },{
          cnName:"字段序号样式设置",enName:"listFieldNumIconStyleSet",type:1,filterName:'hasNumIcon',filterValue:'1',filterType:1
        },{
          cnName:"字段value图标样式设置",enName:"listValueIconStyleSet",type:1
        },{
          cnName:"字段name图标样式设置",enName:"listNameIconStyleSet",type:1
        },{
          cnName:"图片样式设置",enName:"pageFieldImageStyleSet",type:1,filterName:'cssStyle',filterValue:'12,14,21',filterType:1
        }]
      },{
        blockCnName:"进度条设置",
        filterName:'cssStyle',filterValue:'6',filterType:1,
        buttonArr:[{
          cnName:"进度条形式样式设置",enName:"listFieldProgressStyleSet",type:1
        },{
          cnName:"进度条形式分子字段样式设置",enName:"listFieldProgressMoleculeStyleSet",type:1
        },{
          cnName:"进度条形式分割线字段样式设置",enName:"listFieldProgressDivisionStyleSet",type:1
        },{
          cnName:"进度条形式分母字段样式设置",enName:"listFieldProgressDenominatorStyleSet"
        }]
      },{
        blockCnName:"状态查看设置",
        filterName:'cssStyle',filterValue:'3',filterType:1,
        buttonArr:[{
          cnName:"状态查看次数样式设置",enName:"pageFieldLookStyleSet",type:1
        },{
          cnName:"状态收藏次数样式设置",enName:"pageFieldCollectionStyleSet",type:1
        },{
          cnName:"状态购买次数样式设置",enName:"pageFieldBuyStyleSet",type:1
        }]
      },{
        blockCnName:"单行两列设置",
        filterName:'cssStyle',filterValue:'7',filterType:1,
        buttonArr:[{
          cnName:"单行两列最外层样式设置",enName:"listFieldDoubleBoxStyleSet",type:1
        },{
          cnName:"单行两列左侧字段外层样式设置",enName:"listFieldDoubleLeftFieldBoxStyleSet",type:1
        },{
          cnName:"单行两列左侧字段name样式设置",enName:"listFieldDoubleLeftFieldNameStyleSet",type:1
        },{
          cnName:"单行两列左侧字段value样式设置",enName:"listFieldDoubleLeftFieldValueStyleSet",type:1
        },{
          cnName:"单行两列右侧侧字段外层样式设置",enName:"listFieldDoubleRightFieldBoxStyleSet",type:1
        },{
          cnName:"单行两列右侧字段name样式设置",enName:"listFieldDoubleRightFieldNameStyleSet",type:1
        },{
          cnName:"单行两列右侧字段value样式设置",enName:"listFieldDoubleRightFieldValueStyleSet",type:1
        }]
      },{
        blockCnName:"头像设置",
        filterName:'cssStyle',filterValue:'4',filterType:1,
        buttonArr:[{
          cnName:"老师字段外层样式设置",enName:"listFieldTeacherStyleSet",type:1
        },{
          cnName:"有头像的老师字段样式设置",enName:"listFieldPhotoSrcStyleSet",type:1
        },{
          cnName:"有头像的老师头像样式设置",enName:"listFieldPhotoSrcPhotoStyleSet",type:1
        },{
          cnName:"无头像的老师字段样式设置",enName:"listFieldNoPhotoSrcStyleSet",type:1
        }]
      },{
        blockCnName:"卡片头部设置",
        filterName:'cssStyle',filterValue:'10',filterType:1,
        buttonArr:[{
          cnName:"卡片头部定位字段样式设置",enName:"listFieldCardPositionStyleSet",type:1
        }]
      }],
      listFieldBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
            cnName:"中文名称",enName:"lgName",type:2,placeholder:'',ifMust:1
          },{
            cnName:"自定义别名",enName:"zdyFieldAliasName",type:2,placeholder:''
          },{
            cnName:"值",enName:"valuePlugIdJson",type:4,placeholder:'',ifMust:1,filterName:'fieldId',filterValue:'0',filterType:1
          }
          // ,{
          //   cnName:"单击事件",enName:"fOnclickType",type:1,
          //   dicList:[{label:"无",value:"0"},{label:"东",value:"1"},{label:"南",value:"2"},{label:"西",value:"3"},{label:"北",value:"4"},{label:"弹出层",value:"5"}]
          // },{
          //   cnName:"双击事件",enName:"fOnDblclickType",type:1,
          //   dicList:[{label:"无",value:"0"},{label:"东",value:"1"},{label:"南",value:"2"},{label:"西",value:"3"},{label:"北",value:"4"},{label:"弹出层",value:"5"}]
          // }
          ,{
            cnName:"列表宽度",enName:"listWidth",type:2,placeholder:'100'
          },{
            cnName:"默认颜色",enName:"defaultColor",type:2, placeholder:'#666666'
          },{
            cnName:"是否排序",enName:"ifSort",type:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"是否默认排序",enName:"defaultOrderType",type:1,
            dicList:[{label:"无",value:0},{label:"升序",value:1},{label:"降序",value:2}]
          },{
            cnName:"是否显示",enName:"ifShowCol",type:1,
            dicList:[{label:"是",value:1},{label:"否",value:0}]
          },{
            cnName:"列说明",enName:"colTitle",type:2,placeholder:''
          },{
            cnName:"自定义Js",enName:"customJs",type:5,placeholder:''
          },{
            cnName:"自定义sql",enName:"customSql",type:5,placeholder:'',filterName:'fieldId',filterType:4
          }
        ]
      },{
        blockCnName:"字段颜色设置",
        blockType:2,
        blockEnName:"fieldTjSet",
        fieldArr:[{
            cnName:"显示条件",enName:"tjIdJson",type:6,placeholder:''
          },{
            cnName:"颜色",enName:"color",type:2, placeholder:'#666666'
          }
        ]
      }],
      listPageBlockArr:[{blockCnName:"样式设置",
        fieldArr:[{
          cnName:"列表展现形式",enName:"showStyle",type:1,
          dicList:[{label:"默认样式",value:"1"},{label:"左侧大图card",value:"2"},{label:"隐藏",value:"3"},{label:"树形标签二级",value:"4"},{label:"选项卡列表(kw_list_label)",value:"5"},{label:"背景图片CARD",value:"6"},{label:"折叠面板列表(kw_list_collapse)",value:"11"},{label:"轮播图列表(kw_list_carousel)",value:"12"},{label:"单行列表(kw_list_cell)",value:"13"},{label:"知识体系树列表(kw_tree)",value:"14"},{label:"评论列表(kw_list_comment)",value:"15"},{label:"搜索组件(kw_list_search)",value:"16"},{label:"产品菜单分类",value:"17"},{label:"排行榜(kw_ranking_list)",value:"18"},{label:"进度条",value:"19"},{label:"树形表格(二级)",value:"20"},{label:"树形列表(lmf-tree)",value:"21"},{label:"通知资讯",value:"22"},{label:"周课表",value:"23"},{label:"饼图列表(一数据一图表)",value:"24"},{label:"饼图列表(一个图表)",value:"25"},{label:"表格块列表",value:"26"},{label:"知识图谱树",value:"27"}]
        },{
          cnName:"样式模板",enName:"showStyleTemplete",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"基础样式0",value:"0"}]
        },{
          cnName:"几列后收起",enName:"ColAfterHide",type:2,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"有聚合列时聚合数据是否切换显示",enName:"ifShowAllHaving",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"默认显示",value:"1"},{label:"点击切换",value:"2"}]
        },{
          cnName:"是否显示聚合数据条数",enName:"ifShowHavingNum",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"}]
        },{
          cnName:"card是否显示上部结构",enName:"cardSubstructureTop",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"隐藏",value:"1"},{label:"显示",value:"2"}]
        },{
          cnName:"card是否显示下部结构",enName:"cardSubstructure",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"隐藏",value:"1"},{label:"显示",value:"2"}]
        },{
          cnName:"card特殊样式",enName:"cardSpecialBorder",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"底部重叠边框",value:"1"}]
        },{
          cnName:"是否支持滑动切换",enName:"ifTouchChange",type:1,filterName:'showStyle',filterValue:'5',filterType:1,
          dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
        },{
          cnName:"单行列表内容展开方式",enName:"cellContainerOpenMode",type:1,filterName:'showStyle',filterValue:'13',filterType:1,
          dicList:[{label:"右侧展开",value:"1"}]
        },{
          cnName:"card右侧图标示例内容",enName:"cardRightIcon",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"右箭头",value:"enter"},{label:"左箭头",value:"return"}]
        },{
          cnName:"card标题显示",enName:"cardTitle",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"中间",value:"1"}]
        },{
          cnName:"轮播图样式type",enName:"carouselType",type:2,filterName:'showStyle',filterValue:'12',filterType:1,placeholder:'card'
        },{
          cnName:"轮播图自动轮播",enName:"carouselAutoPlay",type:1,filterName:'showStyle',filterValue:'12',filterType:1,placeholder:'card',dicList:[{label:"轮播",value:"1"},{label:"不轮播",value:"2"}]
        },{
          cnName:"轮播图切换触发点击",enName:"carouselChangeClick",type:1,filterName:'showStyle',filterValue:'12',filterType:1,placeholder:'card',dicList:[{label:"触发",value:"1"},{label:"不触发",value:"2"}]
        },{
          cnName:"是否显示卡片背景图片",enName:"isShowCardBgImg",type:1,filterName:'showStyle',filterValue:'13,19',filterType:2,
          dicList:[{label:"显示",value:"1"}]
        },{
          cnName:"是否商品热度标签",enName:"epHotTip",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}]
        },{
          cnName:"商品热度标签位置",enName:"epHotTipPos",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"左上",value:"1"}]
        },{
          cnName:"折叠面板显示进度",enName:"scheduleHide",type:1,filterName:'showStyle',filterValue:'11',filterType:1,
          dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}]
        },{
          cnName:"折叠面板显示左侧进度",enName:"scheduleLeftHide",type:1,filterName:'showStyle',filterValue:'11',filterType:1,
          dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}]
        },{
          cnName:"图片容器宽是否默认",enName:"imgBoxWidth",type:1,filterName:'showStyle',filterValue:'2',filterType:1,
          dicList:[{label:"不默认",value:"1"}]
        },{
          cnName:"card左侧结构内容",enName:"imgPosition",type:1,filterName:'showStyle',filterValue:'2,6',filterType:1,
          dicList:[{label:"背景图片",value:"1"},{label:"图片",value:"3"},{label:"文本",value:"4"}]
        },{
          cnName:"树形标签二级位置设置",enName:"tabAlign",type:1,filterName:'showStyle',filterValue:'4,5',filterType:1,
          dicList:[{label:"left",value:"1"},{label:"center",value:"2"},{label:"right",value:"3"}]
        },{
          cnName:"树形标签二级样式设置",enName:"newTabLine",type:1,filterName:'showStyle',filterValue:'4,5',filterType:1,
          dicList:[{label:"iconBlock",value:"iconBlock"},{label:"no-line",value:"no-line"},{label:"line",value:"line"},{label:"排行榜",value:"paihang"},{label:"card类型标签页",value:"tabPage"},{label:"block",value:"block"},{label:"fillet",value:"fillet"},{label:"intervalTab",value:"intervalTab"}]
        },{
          cnName:"自动刷新数据间隔",enName:"autoRefreshDataSecond",type:2, placeholder:'0'
        },{
          cnName:"列表点击事件",enName:"clickType",type:1,filterName:'showStyle',filterValue:'19',filterType:2,
          dicList:[{label:"无",value:"1"},{label:"加载详情页",value:"2"},{label:"跳转列表页",value:"3"},{label:"跳转详情页",value:"4"},{label:"跳转列表页(并选中)",value:"5"},{label:"后台选项卡打开列表",value:"6"}]
        },{
          cnName:"总记录数显示样式",enName:"pageTotalStyle",type:1,filterName:'showStyle',filterValue:'13,19',filterType:2,
          dicList:[{label:"默认不显示",value:"1"},{label:"上边",value:"2"},{label:"下边",value:"3"}]
        },{
          cnName:"加载更多方式",enName:"loadingMore",type:1,filterName:'showStyle',filterValue:'13,19',filterType:2,
          dicList:[{label:"不显示",value:"0"},{label:"默认",value:"1"},{label:"跳转",value:"2"}]
        },{
          cnName:"无数据提示信息",enName:"noDataMessage",type:2,filterName:'showStyle',filterValue:'12,13,19',filterType:2, placeholder:'0'
        },{
          cnName:"末尾item字体颜色是否不同",enName:"lastfontColor",type:1,filterName:'showStyle',filterValue:'1,12,13,18,19',filterType:2,
          dicList:[{label:"不同",value:"1"}]
        },{
          cnName:"是否吸顶",enName:"setSticky",type:1,filterName:'showStyle',filterValue:'11',filterType:1,
          dicList:[{label:"默认不吸顶",value:"1"},{label:"吸顶",value:"2"}]
        },{
          cnName:"是否锚点定位",enName:"setAnchorPoint",type:1,filterName:'showStyle',filterValue:'11',filterType:1,
          dicList:[{label:"默认不定位",value:"1"},{label:"锚点定位",value:"2"}]
        },{
          cnName:"列表刷新方式",enName:"refreshType",type:1,filterName:'showStyle',filterValue:'13,19',filterType:2,
          dicList:[{label:"数据刷新",value:"1"},{label:"页面刷新",value:"2"},{label:"刷新页面所有列表",value:"3"}]
        },{
          cnName:"图片是否可预览",enName:"imgPreview",type:1,filterName:'showStyle',filterValue:'11,15',filterType:1,
          dicList:[{label:"不可预览",value:"1"},{label:"可预览",value:"2"},{label:"可预览显示提示",value:"3"}]
        },{
          cnName:"上一步是否首页",enName:"prevIfHome",type:1,
          dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
        },{
          cnName:"子表格显示方式",enName:"childTabShowWay",type:1,
          dicList:[{label:"加号展开",value:"1"},{label:"表格右侧追加列",value:"2"}]
        },{
          cnName:"是否显示复选框",enName:"radioIfShow",type:1,
          dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
        },{
          cnName:"是否显示序号列",enName:"indexIfShow",type:1,
          dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
        },{
          cnName:"点击跳转",type:2,
          inputArr:[{cnName:"跳转的对象ID",enName:"clickTableId",placeholder:"跳转的对象ID"},
              {cnName:"跳转的PageID",enName:"clickPageId",placeholder:"跳转的PageID"}]
        },{
          cnName:"加载更多点击跳转",type:2,
          inputArr:[{cnName:"跳转的对象ID",enName:"jumpTableId",placeholder:"跳转的对象ID"},
              {cnName:"跳转的PageID",enName:"jumpPageId",placeholder:"跳转的PageID"}]
        },{
          cnName:"记录搜索历史",type:2,filterName:'showStyle',filterValue:'16',filterType:1,
          inputArr:[{cnName:"对象ID",enName:"searchTableId",placeholder:"对象ID"},
              {cnName:"PageID",enName:"searchPageId",placeholder:"PageID"}]
        },{
          cnName:"分页方式",enName:"paginationWay",type:1,
          dicList:[{label:"分页组件",value:"1"},{label:"加载更多",value:"2"}]
        },{
          cnName:"分页组件显示内容",enName:"paginationLayout",placeholder:"prev, pager, next",type:2,filterName:'paginationWay',filterValue:'1',filterType:1
        },{
          cnName:"分页条数",enName:"pageLimit",placeholder:"20",type:2
        },{
          cnName:"每行个数",type:2,filterName:'showStyle',filterValue:'2',filterType:1,
          inputArr:[{cnName:"xs",enName:"colNumXs",placeholder:"xs"},
              {cnName:"sm",enName:"colNumSm",placeholder:"sm"},
              {cnName:"md",enName:"colNumMd",placeholder:"md"},
              {cnName:"lg",enName:"colNumLg",placeholder:"lg"},
              {cnName:"xl",enName:"colNumXl",placeholder:"xl"}]
        }]
      },{
        blockCnName:"card横向分块",
        blockType:2,
        blockEnName:"setBlockingCard",
        fieldArr:[{
            cnName:"块占比",enName:"width",type:2, placeholder:'最大24'
          }
        ]
      }],
      listPageCssBlockArr:[{
        blockCnName:"折叠面板设置",
        filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"字段外层样式设置",enName:"listPageFieldStyleSet",type:1,filterName:'showStyle',filterValue:'11',filterType:1
        },{
          cnName:"字段name样式设置",enName:"listPageFieldNameStyleSet",type:1,filterName:'showStyle',filterValue:'11',filterType:1
        },{
          cnName:"字段value样式设置",enName:"listPageFieldValueStyleSet",type:1,filterName:'showStyle',filterValue:'11',filterType:1
        },{
          cnName:"折叠面板列表图片样式设置",enName:"pageFieldImageStyleSet",type:1,filterName:'showStyle',filterValue:'11',filterType:1
        },{
          cnName:"折叠面板列表视频样式设置",enName:"pageFieldVideoStyleSet",type:1,filterName:'showStyle',filterValue:'11',filterType:1
        }]
      },{
        blockCnName:"card列表外层",
        // filterName:'showStyle',filterValue:'2',filterType:1,
        buttonArr:[{
          cnName:"card列表容器最外层样式设置",enName:"listPageBoxStyleSet",type:1
        },{
          cnName:"card列表聚合容器样式设置",enName:"listPageCardHavingBoxStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card列表聚合数据条数样式",enName:"listPageCardHavingNumStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card列表容器基础样式设置",enName:"listPageCardBoxStyleSet",type:1
        },{
          cnName:"card列表聚合字段容器样式设置",enName:"listPageCardHavingFieldBoxStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card选择复选框样式",enName:"listRadioCheckStyleSet",type:1,filterName:'radioIfShow',filterValue:'1',filterType:1
        },{
          cnName:"无数据提示信样式设置",enName:"noDataMessageStyleSet",type:1
        },{
          cnName:"分页样式设置",enName:"paginationStyleSet",type:1
        },{
          cnName:"card序号样式",enName:"listPageNumStyleSet",type:1,filterName:'indexIfShow',filterValue:'1',filterType:1
        }]
      },{
        blockCnName:"card单数据层",
        // filterName:'showStyle',filterValue:'2',filterType:1,
        buttonArr:[{
          cnName:"card基础样式设置",enName:"listPageCardCommonStyleSet",type:1
        },{
          cnName:"card中部最外层样式设置",enName:"listPageCardLeftRightBoxStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card上部基础样式设置",enName:"listPageCardTopCommonStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card下部基础样式设置",enName:"listPageCardBottomCommonStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card左侧结构外层基础样式设置",enName:"listPageCardLeftBoxStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card右侧结构内容外层样式设置",enName:"listPageCardRightBoxStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"card右侧结构字段外层样式设置",enName:"listPageCardRightStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        },{
          cnName:"选中数据样式设置",enName:"listPageCardCheckCommonStyleSet",type:1,filterName:'showStyle',filterValue:'2',filterType:1
        }]
      },{
        blockCnName:"图片样式设置",
        // filterName:'showStyle',filterValue:'2',filterType:1,
        buttonArr:[{
          cnName:"图片样式设置",enName:"listPageImageStyleSet",type:1
        },{
          cnName:"图片最外层容器样式设置",enName:"listPageImageBoxStyleSet",type:1,filterName:'showStyle',filterValue:'6',filterType:1
        },{
          cnName:"图片循环层样式设置",enName:"listPageImageForStyleSet",type:1,filterName:'showStyle',filterValue:'6',filterType:1
        },{
          cnName:"图片样式设置",enName:"listPageImageStyleSet",type:1,filterName:'showStyle',filterValue:'6',filterType:1
        }]
      },{
        blockCnName:"单行列表kw_list_cell组件样式设置",
        filterName:'showStyle',filterValue:'13',filterType:1,
        buttonArr:[{
          cnName:"kw_list_cell列表组件的外层样式设置",enName:"listPageCellBoxExternalBoxStyleSet",type:1
        },{
          cnName:"kw_list_cell列表组件内pc左侧样式设置",enName:"listPageCellWithinLeftBoxStyleSet",type:1
        },{
          cnName:"kw_list_cell列表组件内pc右侧样式设置",enName:"listPageCellWithinRightBoxStyleSet",type:1
        },{
          cnName:"kw_list_cell单条样式设置",enName:"listPageCellItemStyleSet",type:1
        }]
      },{
        blockCnName:"折叠面板列表kw_list_collapse组件样式设置",
        filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"kw_list_collapse标题字段基础设置",enName:"listPageCollapseFieldStyleSet",type:1
        },{
          cnName:"kw_list_collapse展开子页面字段name样式设置",enName:"listPageCollapseFieldNameStyleSet",type:1
        },{
          cnName:"kw_list_collapse展开子页面字段value样式设置",enName:"listPageCollapseFieldValueStyleSet",type:1
        }]
      },{
        blockCnName:"排行榜组件样式设置",
        filterName:'showStyle',filterValue:'18',filterType:1,
        buttonArr:[{
          cnName:"排行榜最外层基础样式设置",enName:"listPageRankingBoxStyleSet",type:1
        },{
          cnName:"排行榜顶部装饰基础样式设置",enName:"listPageRankingTopDecorateStyleSet",type:1
        }]
      },{
        blockCnName:"选项卡组件样式设置",
        filterName:'showStyle',filterValue:'4,5',filterType:1,
        buttonArr:[{
          cnName:"选项卡整体样式设置",enName:"listPageTabsBoxCommonStyleSet",type:1
        },{
          cnName:"选项卡tabs组件样式设置",enName:"listPageTabsCommonStyleSet",type:1
        },{
          cnName:"选项卡tab外层样式设置",enName:"listPageTabBoxCommonStyleSet",type:1
        },{
          cnName:"选项卡tab未选中样式设置",enName:"listPageTabDefaultCommonStyleSet",type:1
        },{
          cnName:"选项卡tab选中样式设置",enName:"listPageTabCheckCommonStyleSet",type:1
        },{
          cnName:"选项卡tab鼠标移上样式设置",enName:"listPageTabHoverCommonStyleSet",type:1
        }]
      },{
        blockCnName:"kw_tree样式设置",
        filterName:'showStyle',filterValue:'14,21',filterType:1,
        buttonArr:[{
          cnName:"kw_tree最外层",enName:"listPageTreeOutermostBoxStyleSet",type:1
        },{
          cnName:"kw_tree列表容器",enName:"listPageTreeListBoxStyleSet",type:1
        },{
          cnName:"kw_tree标题",enName:"listPageTreeTitleStyleSet",type:1
        },{
          cnName:"kw_tree第一层树",enName:"listPageTreeFirstStyleSet",type:1
        },{
          cnName:"kw_tree循环层树",enName:"listPageTreeLoopStyleSet",type:1
        }]
      },{
        blockCnName:"轮播图组件样式设置",
        filterName:'showStyle',filterValue:'12',filterType:1,
        buttonArr:[{
          cnName:"轮播外层的样式设置",enName:"pageFieldRotationBoxStyleSet",type:1
        },{
          cnName:"轮播内容的样式设置",enName:"pageFieldRotationCommonStyleSet",type:1
        }]
      },{
        blockCnName:"kw_list_comment组件样式设置",
        filterName:'showStyle',filterValue:'15',filterType:1,
        buttonArr:[{
          cnName:"kw_list_comment组件的外层样式设置",enName:"listPageCommentBoxStyleSet",type:1
        }]
      },{
        blockCnName:"饼图列表组件样式设置",
        filterName:'showStyle',filterValue:'24,25',filterType:1,
        buttonArr:[{
          cnName:"图表样式设置",enName:"pieChartStyleSet",type:2
        },{
          cnName:"图表统一的legend样式设置",enName:"pieChartCommonStyleSet",type:2
        }]
      },{
        blockCnName:"表格列表组件样式设置",
        filterName:'showStyle',filterValue:'1',filterType:1,
        buttonArr:[{
          cnName:"表格列表的表头行样式设置",enName:"listTableHeadRowStyleSet",type:1
        },{
          cnName:"表格列表的数据行样式设置",enName:"listTableDataRowStyleSet",type:1
        }]
      }],
      listFilterBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
          cnName:"固定前几列",enName:"fixdRow",type:2,placeholder:''
        },{
          cnName:"是否默认加载",enName:"ifDefaultLoad",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        },{
          cnName:"是否统计记录数",enName:"ifSearchCount",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        },{
          cnName:"是否支持空闲时间段筛选",enName:"ifFreeTimeSearch",type:1,
          dicList:[{label:"否",value:0},{label:"是",value:1}]
        },{
          cnName:"非空闲时段是否显示",enName:"ifShowBusyTime",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        },
        // {
        //   cnName:"显示条件是否走sql",enName:"ifShowTjSql",type:1,
        //   dicList:[{label:"否",value:0},{label:"是",value:1}]
        // },
        {
          cnName:"左侧树",enName:"areaPageCombo",type:18,placeholder:'',filterPageTypeValue:"16"
        },{
          cnName:"左侧树与主数据联动过滤",enName:"leftTreePlugJson",type:6,placeholder:'',filterEnName:"areaPageCombo",filterFieldEnName:"tableId"
        }]
      },{
        blockCnName:"过滤设置",
        fieldArr:[{
          cnName:"是否默认展开",enName:"ifUnfoldsrch",type:1,
          dicList:[{label:"否",value:0},{label:"是",value:1}]
        },{
          cnName:"每页条数",enName:"pageLimit",type:2,placeholder:''
        },{
          cnName:"是否自动换行",enName:"ifAutoChangeLine",type:1,
          dicList:[{label:"否",value:0},{label:"是",value:1}]
        },{
          cnName:"是否走sql优化",enName:"ifSpecialPage",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        },{
          cnName:"是否拖动排序",enName:"ifdragSort",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        }]
      },{
        blockCnName:"默认排序",
        blockType:2,
        blockEnName:"orderArr",
        fieldArr:[{
            cnName:"值插件",enName:"valuePlugIdJson",type:4,placeholder:''
          },{
            cnName:"排序方向",enName:"orderType",type:1,
            dicList:[{label:"降序",value:0},{label:"升序",value:1}]
          }
        ]
      },{
        blockCnName:"默认过滤",
        blockType:2,
        blockEnName:"defaultFilterArr",
        fieldArr:[{
          cnName:"是否联动过滤",enName:"ifJoinFilter",type:1,defaultValue:2,
          dicList:[{label:"是",value:1},{label:"否",value:2}]
        },{
          cnName:"联动过滤对象",enName:"glPageObjTable",type:8,placeholder:'',filterName:'ifJoinFilter',filterValue:'1',filterType:1
        },{
          cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:'',filterName:'ifJoinFilter',filterValue:'2',filterType:1
        },{
          cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:'',xnTableIdEnName:"glPageObjTable",xnTableIdEnFieldName:"tableId",filterName:['ifJoinFilter','glPageObjTable'],filterValue:['1',''],filterType:[1,3]
        }]
      },{
        blockCnName:"行颜色设置",
        blockType:2,
        blockEnName:"rowColorSet",
        fieldArr:[{
          cnName:"条件设置",enName:"tjIdJson",type:6,placeholder:'',ifMust:1
        },{
          cnName:"颜色",enName:"color",type:2, placeholder:'#666666'
        }]
      },{
        blockCnName:"加号展开块",
        blockType:2,
        blockEnName:"childTabs",
        fieldArr:[{
          cnName:"显示块名称",enName:"childPageName",type:2,placeholder:''
        },{
          cnName:"关联对象",enName:"glPageObjTable",type:8,placeholder:'',
        },{
          cnName:"页面",enName:"childPage",type:7,placeholder:'',filterEnName:"glPageObjTable",filterFieldEnName:"tableId",filterName:'glPageObjTable',filterType:3,addPageName:"childPageName",ifZdyAddPage:1
        },{
          cnName:"是否显示搜索条件",enName:"ifShowSearch",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        },{
          cnName:"是否自定义关联条件",enName:"ifZdyGl",type:1,
          dicList:[{label:"否",value:0},{label:"是",value:1}]
        },
        {
          cnName:"自定义关联条件",enName:"zdyChildGlSql",type:5,placeholder:''
        },
        {
          cnName:"关联条件",enName:"childPageTjList",type:9,placeholder:'',
          fieldArr:[{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:'',tableIdSourceType:"parent",filterEnName:"glPageObjTable",filterFieldEnName:"tableId"
          }]
        },
        {
          cnName:"启用条件",enName:"tabTjSet",type:9,placeholder:'',
          fieldArr:[{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:''
          }]
        },
        {
          cnName:"禁用条件",enName:"tabJyTjSet",type:9,placeholder:'',
          fieldArr:[{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:''
          }]
        }]
      },{
        blockCnName:"自定义设置",
        fieldArr:[{
          cnName:"默认SQL",enName:"sql",type:5,placeholder:'',ifUpdate:1
        },{
          cnName:"自定义SQL",enName:"zdyListSql",type:5,placeholder:''
        },{
          cnName:"自定义joinSQL",enName:"zdyJoinSql",type:5,placeholder:''
        },{
          cnName:"自定义whereSQL",enName:"zdyWhereSql",type:5,placeholder:''
        },{
          cnName:"自定义vuejs",enName:"zdyVueJs",type:5,placeholder:''
        }]
      }],
      searchFieldBlockArr:[{blockCnName:"样式设置",
          fieldArr:[{
            cnName:"是否收起",enName:"ifClose",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否显示外围边框",enName:"showLine",type:1,
            dicList:[{label:"不显示",value:"0"},{label:"上线",value:"1"},{label:"下线",value:"2"}]
          },{
            cnName:"展现形式",enName:"showStyle",type:1,
            dicList:[{label:"默认样式",value:"1"},{label:"标签搜索",value:"2"},{label:"日历(周)",value:"3"},{label:"日历(月)",value:"4"},{label:"全局搜索组件",value:"5"},{label:"输入搜索组件",value:"6"},{label:"下拉搜索组件",value:"7"},{label:"按钮标签",value:"8"},{label:"隐藏",value:"9"},{label:"常用日期",value:"10"},{label:"标签轴搜索",value:"11"},{label:"复选搜索",value:"12"}]
          },{
            cnName:"标签搜索name是否显示",enName:"searchNameHide",type:1,filterName:'cssStyle',filterValue:'3',filterType:1,
            dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}]
          },{
            cnName:"name上方是否有图片",enName:"nameTopImg",type:1,
            dicList:[{label:"有",value:"1"}],filterName:'showStyle',filterValue:'1,2,6,7',filterType:1,
          },{
            cnName:"是否显示左右可滑动提示",enName:"canScrollTip",type:1,dicList:[{label:"默认不显示",value:"1"},{label:"显示",value:"2"}],filterName:'showStyle',filterValue:'1,2',filterType:1
          },{
            cnName:"搜索框placeholder",enName:"searchPlaceholder",type:1,filterName:'showStyle',filterValue:'1,6',filterType:1
          },{
            cnName:"搜索框icon",enName:"searchIconHide",type:1,dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"},{label:"只显示icon图标",value:"3"}],filterName:'showStyle',filterValue:'1,5,6',filterType:1
          },{
            cnName:"标签搜索第一项内容",enName:"searchNameCustom",type:2,filterName:'showStyle',filterValue:'1,2,7,12',filterType:1
          },{
            cnName:"标签搜索第一项内容显示",enName:"searchNameCustomHide",type:1,filterName:'showStyle',filterValue:'1,2,7,12',filterType:1,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"标签搜索默认选中",enName:"defaultCheck",type:1,filterName:'showStyle',filterValue:'1,2,7,11,12',filterType:1,
            dicList:[{label:"第一项",value:"1"},{label:"全部选中",value:"2"},{label:"最后一项",value:"3"}]
          },{
            cnName:"tabs下边框",enName:"ifShowBottomLine",type:1,filterName:'showStyle',filterValue:'1,2',filterType:1,
            dicList:[{label:"显示",value:"1"}]
          },{
            cnName:"是否有标签搜索分割线",enName:"hasDevide",type:1,filterName:'showStyle',filterValue:'1,27',filterType:1,
            dicList:[{label:"默认没有",value:"1"},{label:"有",value:"2"}]
          },{
            cnName:"标签搜索样式设置",enName:"newTabLine",type:1,filterName:'showStyle',filterValue:'1,2',filterType:1,
            dicList:[{label:"iconBlock",value:"iconBlock"},{label:"no-line",value:"no-line"},{label:"line",value:"line"},{label:"排行榜",value:"paihang"},{label:"card类型标签页",value:"tabPage"},{label:"block",value:"block"},{label:"fillet",value:"fillet"},{label:"intervalTab",value:"intervalTab"}]
          },{
            cnName:"是否吸顶",enName:"setSticky",type:1,dicList:[{label:"默认不吸顶",value:"1"},{label:"吸顶",value:"2"}]
          },{
            cnName:"点击跳转",type:2,
            inputArr:[{cnName:"跳转的对象ID",enName:"clickTableId",placeholder:"跳转的对象ID"},
                {cnName:"跳转的PageID",enName:"clickPageId",placeholder:"跳转的PageID"}]
          },{
            cnName:"数据联动过滤",enName:"filterParent",type:2,placeholder:"字段下标(1)"
          }]
        }
      ],
      searchFieldCssBlockArr:[{
        blockCnName:"字段基础设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"字段循环层样式设置",enName:"searchFieldForStyleSet",type:1
        },{
          cnName:"字段外层样式设置",enName:"searchFieldStyleSet",type:1
        },{
          cnName:"字段name样式设置",enName:"searchFieldNameStyleSet",type:1
        },{
          cnName:"字段value样式设置",enName:"searchFieldValueStyleSet",type:1
        },{
          cnName:"图标样式设置",enName:"searchFieldIconStyleSet",type:1,filterName:'showStyle',filterValue:'5,6',filterType:1
        },{
          cnName:"输入搜索样式设置",enName:"searchFieldInputStyleSet",type:1,filterName:'showStyle',filterValue:'6',filterType:1
        }]
      },{
        blockCnName:"选项卡样式设置",
        filterName:'showStyle',filterValue:'2,6,12',filterType:1,
        buttonArr:[{
          cnName:"选项卡整体样式设置",enName:"searchFieldTabsBoxCommonStyleSet",type:1
        },{
          cnName:"选项卡tabs组件样式设置",enName:"searchFieldTabsCommonStyleSet",type:1
        },{
          cnName:"选项卡tab组件样式设置",enName:"searchFieldTabCommonStyleSet",type:1
        },{
          cnName:"选项卡tab未选中样式设置",enName:"searchFieldTabDefaultCommonStyleSet",type:1
        },{
          cnName:"选项卡tab选中样式设置",enName:"searchFieldTabCheckCommonStyleSet",type:1
        }]
      }],
      searchFieldBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
            cnName:"中文名称",enName:"lgName",type:2,placeholder:'',ifMust:1
          },{
            cnName:"自定义别名",enName:"zdyFieldAliasName",type:2,placeholder:''
          },{
            cnName:"值插件",enName:"valuePlugIdJson",type:4,placeholder:'',ifMust:1,filterName:'fieldId',filterValue:'0',filterType:1
          },{
            cnName:"选择形式:",enName:"chooseType",type:1,dicList:[{label:"请选择",value:"-1"},{label:"弹出层",value:"1"},{label:"下拉框",value:"2"}],filterName:'fieldRole',filterValue:'0',filterType:1
          },{
            cnName:"弹出层页面:",enName:"tcPageId",type:14,filterEnName:'valuePlugIdJson',filterFieldEnName:'tableId',filterPageTypeValue:'15',filterName:'fieldRole',filterValue:'0',filterType:1,ifZdyAddPage:1,addPageName:'lgName'
          },{
            cnName:"弹出层tableId",enName:"tcTableId",type:2,placeholder:'',filterName:'fieldRole',filterValue:'0',filterType:1
          }
          // ,{
          //   cnName:"默认值",enName:"defaultValuePlugIdJson",type:4,placeholder:'',ifMust:1,filterName:'fieldId',filterValue:'0',filterType:1
          // }
          ,{
            cnName:"默认显示值",enName:"dicChildShow",type:15,filterEnName:'dicParId',filterName:'dicParId',filterType:3
          },{
            cnName:"默认选中值",enName:"dicDefaultSelect",type:15,filterEnName:'dicParId',filterName:'dicParId',filterType:3
          },{
            cnName:"日期格式",enName:"dateType",type:1,
            dicList:[{label:"yyyy-MM-dd",value:"yyyy-MM-dd"},{label:"yyyy/MM/dd",value:"yyyy/MM/dd"},{label:"yyyyMMdd",value:"yyyyMMdd"},{label:"yyyy-MM-dd HH:mm:ss",value:"yyyy-MM-dd HH:mm:ss"},{label:"yyyy-MM-dd HH:mm",value:"yyyy-MM-dd HH:mm"},{label:"HH:mm",value:"HH:mm"},{label:"HH:mm:ss",value:"HH:mm:ss"},{label:"yyyy",value:"yyyy"},{label:"yyyy-MM",value:"yyyy-MM"},{label:"MM-dd",value:"MM-dd"},{label:"MM",value:"MM"},{label:"dd",value:"dd"}],filterName:'fieldType',filterValue:'3',filterType:1
          },{
            cnName:"默认日期范围",enName:"defDateRange",type:1,
            dicList:[{label:"--请选择--",value:0},{label:"本月",value:1},{label:"本周",value:2},{label:"本年",value:4},{label:"与当前间隔",value:3},{label:"昨天",value:5},{label:"上周",value:6},{label:"上月",value:7},{label:"去年",value:8},{label:"上季度",value:9},{label:"本季度",value:10}],filterName:'fieldType',filterValue:'3',filterType:1
          },{
            cnName:"间隔天数",enName:"betweenDay",type:2,placeholder:'',filterName:'defDateRange',filterValue:'3',filterType:1
          },{
            cnName:"日期搜索范围(天)",enName:"dateSearchRang",type:2,placeholder:'',filterName:'fieldType',filterValue:'3',filterType:1
          },{
            cnName:"是否连带选中",enName:"ifLdSelect",type:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}],filterName:'fieldType',filterValue:'3',filterType:1
          },{
            cnName:"是否忽视权限",enName:"neglectLimitSearch",type:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"是否必填",enName:"ifMustReg",type:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"自定义sql",enName:"zdyFieldSql",type:5,placeholder:''
          },{
            cnName:"数据字典",enName:"dicParId",type:2,placeholder:'',filterName:'noShow',filterType:3
          },{
            cnName:"字段类型",enName:"fieldType",type:2,placeholder:'',filterName:'noShow',filterType:3
          },{
            cnName:"字段角色",enName:"fieldRole",type:2,placeholder:'',filterName:'noShow',filterType:3
          }
        ]
      }],
      searchSetBlockArr:[{blockCnName:"样式设置",
        fieldArr:[{
          cnName:"搜索块展现形式",enName:"searchShowStyle",type:1,
          dicList:[{label:"PC显示搜索块展开",value:"1"},{label:"PC不显示搜索块",value:"2"}]
        },{
          cnName:"外层搜索按钮显示形式",enName:"searchButtonStyle",type:1,
          dicList:[{label:"不显示",value:"1"},{label:"最后显示",value:"2"},{label:"搜索框后面显示",value:"3"}]
        }]
      }],
      searchSetCssBlockArr:[{
        blockCnName:"基础设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"搜索块样式设置",enName:"searchBlockBoxStyleSet",type:1,
        },{
          cnName:"搜索按钮条的样式设置",enName:"searchButtonBoxStyleSet",type:1,
        },{
          cnName:"搜索按钮的样式设置",enName:"searchCommonStyleSet",type:1,
        }]
      }],
      buttonSetBlockArr:[{blockCnName:"样式设置",
          fieldArr:[{
            cnName:"结构设置",enName:"cssStyle",type:1,
            dicList:[{label:"默认结构",value:"1"},{label:"隐藏",value:"2"},{label:"提交订单栏(van-submit-bar)",value:"6"},{label:"主标题下按钮",value:"7"},{label:"页面浮动按钮",value:"8"},{label:"右上角按钮组",value:"9"},{label:"提交订单栏(van-button)",value:"10"},{label:"聚合字段按钮",value:"11"}]
          },{
            cnName:"按钮名称",enName:"buttonName",type:2,placeholder:''
          },{
            cnName:"是否无视权限",enName:"ifRoleLimit",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"在第几块显示",enName:"isBlockShow",type:2
          },{
            cnName:"按钮文本显示隐藏",enName:"fontHide",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"隐藏文本",value:"2"}]
          },{
            cnName:"页面打开方式",enName:"openWay",type:1,
            dicList:[{label:"默认打开页面",value:"1"},{label:"弹出层打开",value:"2"},{label:"横屏打开",value:"3"},{label:"新开页面页面",value:"4"},{label:"后台选项卡打开",value:"5"},{label:"加载详情页",value:"6"}]
          },{
            cnName:"按钮位置设置",enName:"cssBgPosition",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"右下",value:"2"},{label:"左下",value:"3"}]
          },{
            cnName:"按钮图片显示隐藏",enName:"imageShowHide",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"按钮背景图片显示隐藏",enName:"imageBgShowHide",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"按钮背景图片",enName:"btnBgImage",type:3
          },{
            cnName:"按钮图标",enName:"btnImage",type:3
          },{
            cnName:"后续操作设置",enName:"nextOperaType",type:1,
            dicList:[{label:"默认(本页刷新)",value:"1"},{label:"跳转详情页面",value:"2"},{label:"跳转列表页面",value:"3"},{label:"打开支付页面",value:"4"},{label:"打开联系客服",value:"5"},{label:"打开二维码分享页面",value:"6"},{label:"记录操作历史",value:"7"},{label:"跳转详情页面(并联系客服)",value:"8"},{label:"报名成功弹窗",value:"9"},{label:"打开联系客服(打开53页面)",value:"10"},{label:"关闭本页返回并刷新上一页",value:"11"},{label:"刷新子选项卡列表",value:"12"},{label:"自动登录",value:"13"},{label:"打开关联添加",value:"14"}]
          },{
            cnName:"后续是否关闭本页跳转",enName:"nextOperaCloseNow",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"弹出消息时长",enName:"delayMillisecond",type:2,placeholder:"0为不自动关闭"
          },{
            cnName:"后续页面是否走自定义",enName:"nextOperaIfZdy",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否翻墙",enName:"ifNoLogin",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"头条是否上报",enName:"headlinesReport",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"上报",value:"1"},{label:"不上报",value:"2"}]
          },{
            cnName:"操作后是否弹出提示",enName:"ifShowDialog",type:1,filterName:'cssStyle',filterValue:'2',filterType:2,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"后续跳转",type:2,inputArr:[
              {cnName:"对象ID",enName:"clickTableId",placeholder:"clickTableId"},
              {cnName:"PageID",enName:"clickPageId",placeholder:"clickPageId"},
              {cnName:"PageType",enName:"clickPageType",placeholder:"clickPageType"}]
          }]
        }
      ],
      buttonSetCssBlockArr:[{
        blockCnName:"基础设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"按钮整体样式设置",enName:"buttonSetButtonStyleSet",type:1,
        },{
          cnName:"背景图片样式设置",enName:"buttonSetBgImageStyleSet",type:1,
        },{
          cnName:"图片样式设置",enName:"buttonSetImageStyleSet",type:1,
        },{
          cnName:"文字样式设置",enName:"buttonSetFieldStyleSet",type:1,
        }]
      }],
      buttonBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
            cnName:"按钮类型",enName:"buttonType",type:1,
            dicList:[{label:"修改",value:12,filterType:32},{label:"删除",value:13,filterType:32},{label:"查看",value:15,filterType:32},{label:"关联添加",value:18,filterType:32},{label:"添加",value:0,filterType:31},{label:"批量修改",value:2,filterType:31},{label:"批量删除",value:3,filterType:31},{label:"导入",value:4,filterType:31},{label:"导出",value:5,filterType:31},{label:"直接操作",value:21},{label:"自定义按钮",value:19,filterType:32},{label:"自定义操作",value:9,filterType:9,filterType:31},{label:"打印",value:20}],ifMust:1
          },{
            cnName:"按钮名称",enName:"buttonName",type:2,placeholder:'',ifMust:1
          },{
            cnName:"按钮组名称",enName:"buttonTabName",type:2,placeholder:''
          },
          
          {
            cnName:"跳转路径",enName:"startTurnPageDic",type:1,dicList:[{label:"做试卷",value:"doExamPaper",remark:"数据中:SHOW_TYPE(做卷子形式),ZD_IF_DO(是否已做),EXAM_PAPER_ID(试卷主键),S_E_P_ID(学员试卷主键)"},{label:"去图片查看功能",value:"imageCanvas",remark:"imageCanvas:画布生成功能"},{label:"直接打开附件按钮",value:"toDownload",remark:"toDownload:字段别名(文件地址名称)"},{label:"直接打开文件",value:"toOpenFile",remark:"toOpenFile:字段别名(文件地址名称)"},{label:"直接预览文件",value:"toPreviewFile",remark:"toPreviewFile(需要字段别名:FILE_DOWNADDRESS:文件地址名称,FILE_BACKGROUND_AUDIO:背景音频地址)"},{label:"打开动态页面",value:"toPage",remark:"toPage(需要字段别名:TABLE_ID:表ID,PAGE_ID:页面ID,PAGE_TYPE:页面类型,MAIN_ID:主键)"},{label:"跳转列表页",value:"toList",remark:"toList:tableId:pageId"},{label:"跳转查看页",value:"toLook",remark:"toLook:tableId:pageId:dataId(可选)"},{label:"跳转mailHome页面",value:"toHome",remark:"toHome"},{label:"返回上一页",value:"goBack",remark:"goBack"},{label:"退出登录",value:"loginOut",remark:"loginOut"},{label:"小程序扫码",value:"toScan",remark:"toScan:tableId:pageId:dataId(可选)"},{label:"永中文档在线编辑",value:"toYzEdit",remark:"toYzEdit(需要字段别名:FILE_NAME:文件名称,FILE_DOWNADDRESS:文件地址名称,FILE_EDIT_TYPE:是否可编辑)"},{label:"无操作",value:"noEvent",remark:"noEvent"},{label:"打印",value:"toPrint",remark:"toPrint"},{label:"vue导出",value:"toVueExport",remark:"toVueExport"}],filterName:'buttonType',filterValue:'19,9',filterType:1
          },
          {
            cnName:"跳转路径",enName:"startTurnPageUrl",type:2,filterName:'buttonType',filterValue:'19,9',filterType:1
          },
          {
            cnName:"弹出层宽高(%)",type:2,
            inputArr:[{
              cnName:"弹出层宽度(%)",enName:"onclickPageWidth",type:2,placeholder:'弹出层宽度(%)'
            },{
              cnName:"弹出层高度(%)",enName:"onclickPageHeight",type:2,placeholder:'弹出层高度(%)'
            }]
          },{
            cnName:"页面打开方式",enName:"onclickType",type:1,
            dicList:[{label:"弹出层",value:5},{label:"无",value:6},{label:"跳转页面",value:7},{label:"ifreame选项卡",value:8},{label:"新窗口",value:9},{label:"VUE新页面",value:10}],ifMust:1,filterName:'buttonType',filterValue:'13,3',filterType:2
          },{
            cnName:"关联字段",enName:"relationFieldObj",type:10,filterEnName:'nowTable',filterName:'buttonType',filterValue:'12,15,18',filterType:1
          },
          //修改和查看页面
          {
            cnName:"打开页面",enName:"startTurnPage",type:11,filterEnName:'relationFieldObj',filterFieldEnName:'relationTableId',filterPageTypeEnName:'buttonType',filterName:'buttonType',filterValue:'12,15',filterType:1
          },
          //关联添加
          {
            cnName:"打开页面",enName:"startTurnPage",type:19,filterEnName:'relationFieldObj',filterFieldEnName:'relationTableId',filterPageTypeEnName:'buttonType',filterName:'buttonType',filterValue:'18',filterType:1
          },
          //添加页面
          {
            cnName:"打开页面",enName:"startTurnPage",type:14,filterPageTypeEnName:'buttonType',filterPageTypeValue:'5',filterName:'buttonType',filterValue:'0',filterType:1
          },
          //批量修改
          {
            cnName:"打开页面",enName:"startTurnPage",type:14,filterPageTypeEnName:'buttonType',filterPageTypeValue:'8',filterName:'buttonType',filterValue:'2',filterType:1
          },{
            cnName:"是否区分角色权限",enName:"ifRoleLimit",type:1,dicList:[{label:"是",value:0},{label:"否",value:1}]
          },{
            cnName:"操作前提醒",enName:"operaPrompt",type:2,placeholder:''
          },{
            cnName:"提醒存在时间",enName:"remindTime",type:2, placeholder:''
          },{
            cnName:"调用前JS",enName:"jsBeforeInvok",type:5,placeholder:''
          },{
            cnName:"调用后JS",enName:"jsAfterInvok",type:5,placeholder:''
          },{
            cnName:"自定义外键sql",enName:"zdyFieldSql",type:5,placeholder:''
          },{
            cnName:"自定义按钮sql",enName:"zdyButtonSql",type:5,placeholder:''
          },
          // {
          //   cnName:"启用禁用是否走sql处理",enName:"ifBtnTjSql",type:1,dicList:[{label:"否",value:0},{label:"是",value:1}]
          // },
          {
            cnName:"删除按钮关联表设置",enName:"relationFieldList",type:12,filterName:'buttonType',filterValue:'13,3',filterType:1,filterJson:{
              showFilterType:20,
              mainTableId:that.tableId
            },fieldArr:[{
              cnName:"字段名称",enName:"fieldCnName",type:2,placeholder:''
            },{
              cnName:"是否删除",enName:"isDelete",type:1,dicList:[{label:"有数据不可删除",value:0},{label:"联动删除",value:1},{label:"无操作",value:2}]
            }]
          },{
            cnName:"自定义触发器",enName:"directButtonSetId",type:13,filterName:'buttonType',filterValue:'21',filterType:1
          }
        ]
      },{
        blockCnName:"启用条件设置",
        blockType:2,
        blockEnName:"buttonTjSet",
        filterName:'buttonType',filterValue:'0,2,3,4,5',filterType:2,
        fieldArr:[{
            cnName:"显示条件",enName:"tjIdJson",type:6,placeholder:''
          },{
            cnName:"是否显示(不满足条件)",enName:"ifBtnShow",type:1,dicList:[{label:"否",value:0},{label:"是",value:1}]
          }
        ]
      },{
        blockCnName:"禁用条件设置",
        blockType:2,
        blockEnName:"buttonJyTjSet",
        filterName:'buttonType',filterValue:'0,2,3,4,5',filterType:2,
        fieldArr:[{
            cnName:"显示条件",enName:"tjIdJson",type:6,placeholder:''
          },{
            cnName:"是否显示(不满足条件)",enName:"ifBtnShow",type:1,dicList:[{label:"否",value:0},{label:"是",value:1}]
          }
        ]
      }],
      pageFieldBlockArr:[{blockCnName:"样式设置",
          fieldArr:[{
            cnName:"展现形式",enName:"showStyle",type:1,
            dicList:[{label:"默认样式",value:"1"},{label:"副标题",value:"10"},{label:"轮播图",value:"2"},{label:"纵向标签显示(kw_label_col)",value:"3"},{label:"切换组件",value:"4"},{label:"弹出层组件(默认打开)",value:"5"},{label:"横向标签显示(kw_label_row)",value:"6"},{label:"隐藏不显示",value:"7"},{label:"带背景图片的title",value:"8"},{label:"主标题",value:"9"},{label:"人员头像列表",value:"11"},
            // {label:"单行两列",value:"12"},
            {label:"徽章称号",value:"13"},{label:"图片",value:"14"},{label:"状态聚合样式",value:"15"},{label:"星级评价",value:"16"},{label:"富文本",value:"18"},{label:"进度条",value:"19"},{label:"单行右侧选择",value:"20"},{label:"倒计时",value:"21"},{label:"倒计时(隐藏)",value:"22"},{label:"视频",value:"23"},{label:"音频",value:"24"},{label:"角色看板",value:"25"},{label:"定位组件-图片",value:"26"},{label:"定位组件-内容",value:"27"},{label:"地址选择",value:"28"},{label:"数字加减",value:"29"},{label:"地图地址",value:"30"},{label:"发帖编辑器",value:"31"},{label:"角色栏目",value:"32"},{label:"排课组件",value:"33"},{label:"工作台组件",value:"34"},{label:"周排课组件",value:"35"},{label:"直播流播放",value:"36"},{label:"试题组件",value:"37"},{label:"全景图组件",value:"38"},{label:"二维码",value:"39"},{label:"条码码",value:"40"}]
          },{
            cnName:"是否拖动上传",enName:"fileUploadDrag",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"上传文件类型",enName:"fileType",type:1,
            dicList:[{label:"图片",value:"1"},{label:"录音",value:"2"},{label:"视频",value:"3"},{label:"全部",value:"4"}]
          },{
            cnName:"最大最小值",type:2,filterName:'showStyle',filterValue:'29',filterType:1,
            inputArr:[{cnName:"最小值",enName:"minNumber",placeholder:"1"},
                {cnName:"最大值",enName:"maxNumber",placeholder:"100"}]
          },{
            cnName:"是否显示查看次数",enName:"isShowLook",type:1,filterName:'showStyle',filterValue:'15',filterType:1,
            dicList:[{label:"isShowLook",value:"0"},{label:"隐藏",value:"1"}]
          },{
            cnName:"是否显示收藏次数",enName:"isShowStar",type:1,filterName:'showStyle',filterValue:'15',filterType:1,
            dicList:[{label:"默认显示",value:"0"},{label:"隐藏",value:"1"}]
          },{
            cnName:"图片是否可预览",enName:"imgPreview",type:1,filterName:'showStyle',filterValue:'14',filterType:1,
            dicList:[{label:"不可预览",value:"1"},{label:"可预览",value:"2"},{label:"可预览显示提示",value:"3"}]
          },{
            cnName:"弹出层是否隐藏",enName:"dialogIfHide",type:1,filterName:'showStyle',filterValue:'1,5',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"下拉框类型",enName:"selectType",type:1,
            dicList:[{label:"box框",value:"1"},{label:"下拉框",value:"2"}]
          },{
            cnName:"是否自动播放",enName:"ifAutoPlay",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"播放结束刷新逻辑",enName:"overRefreshType",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"选项卡刷新",value:"1"},{label:"本页刷新",value:"2"}]
          },{
            cnName:"禁用拖动快进",enName:"ifBanFast",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"禁用",value:"1"},{label:"不禁用",value:"2"}]
          },{
            cnName:"是否显示封面及音频文本",enName:"ifShowSentences",type:1,filterName:'showStyle',filterValue:'24',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"是否显示播放进度条",enName:"ifShowSlider",type:1,filterName:'showStyle',filterValue:'24',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"},{label:"背景音频",value:"3"}]
          },{
            cnName:"轮播图previous-margin",enName:"plantingPreviousMargin",type:2,filterName:'showStyle',filterValue:'6',filterType:1,
            placeholder:"10rpx"
          },{
            cnName:"轮播图next-margin",enName:"plantingNextMargin",type:2,filterName:'showStyle',filterValue:'6',filterType:1,
            placeholder:"10rpx"
          },{
            cnName:"轮播图圆点提示",enName:"plantingIndicatorDots",type:1,filterName:'showStyle',filterValue:'6',filterType:1,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"是否短信校验",enName:"ifPhoneMsgCheck",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"在第几块显示",enName:"isBlockShow",type:2
          },{
            cnName:"图片位置",enName:"imgPosition",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"无",value:"0"},{label:"背景图片",value:"1"},{label:"上部图片",value:"2"},{label:"左侧图片",value:"3"}]
          },{
            cnName:"字段图标图片",enName:"iconImage",type:3,filterName:'showStyle',filterValue:'2,7',filterType:2
          },{
            cnName:"标题显示类型",enName:"titleNameHide",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"显示name和内容",value:"1"},{label:"不显示name",value:"2"},{label:"name在内容下方",value:"3"}]
          },{
            cnName:"name是否显示冒号(:)",enName:"nameShowIcon",type:1,filterName:'titleNameHide',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"价格单位设置",enName:"priceUnit",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"无",value:""},{label:"￥",value:"￥"},{label:"-",value:"-"}]
          },{
            cnName:"单位字体大小设置",enName:"priceUnitSize",type:2,filterName:'showStyle',filterValue:'2,7',filterType:2, placeholder:'10px'
          },{
            cnName:"单行两列右侧类型",enName:"rightType",type:1,filterName:'showStyle',filterValue:'12',filterType:1,
            dicList:[{label:"按钮",value:"1"}]
          },{
            cnName:"是否显示跳转icon",enName:"jumpIcon",type:1,filterName:'showStyle',filterValue:'2',filterType:2,
            dicList:[{label:"显示",value:"1"}]
          },{
            cnName:"点击事件",enName:"clickType",type:1,
            dicList:[{label:"跳转列表页",value:"3"},{label:"跳转详情页",value:"4"},{label:"点击复制",value:"5"}]
          },{
            cnName:"点击跳转",type:2,
            inputArr:[{cnName:"跳转的对象ID",enName:"clickTableId",placeholder:"跳转的对象ID"},
                {cnName:"跳转的PageID",enName:"clickPageId",placeholder:"跳转的PageID"}]
          },{
            cnName:"富文本config",enName:"UEditorConfig",type:5,
          }]
      }],
      pageFieldCssBlockArr:[{
        blockCnName:"字段设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"字段外层样式设置",enName:"pageFieldStyleSet",type:1,filterName:'showStyle',filterValue:'9,39,40',filterType:2
        },{
          cnName:"字段name样式设置",enName:"pageFieldNameStyleSet",type:1,filterName:'showStyle',filterValue:'9,39,40',filterType:2
        },{
          cnName:"副标题字段name外层样式设置",enName:"pageFieldNameBoxStyleSet",type:1,filterName:'showStyle',filterValue:'10',filterType:1
        },{
          cnName:"字段value样式设置",enName:"pageFieldValueStyleSet",type:1
        },{
          cnName:"字段循环层样式设置",enName:"pageForFieldStyleSet",type:1,filterName:'showStyle',filterValue:'9',filterType:2
        },{
          cnName:"图片样式设置",enName:"pageFieldImageStyleSet",type:1,filterName:'showStyle',filterValue:'8,39,40',filterType:2
        },{
          cnName:"单行两列最外层样式设置",enName:"pageFieldDoubleBoxStyleSet",type:1,filterName:'showStyle',filterValue:'12',filterType:1
        }]
      },{
        blockCnName:"状态聚合样式设置",
        filterName:'showStyle',filterValue:'15',filterType:1,
        buttonArr:[{
          cnName:"查看次数样式设置",enName:"pageFieldLookStyleSet",type:1
        },{
          cnName:"收藏次数样式设置",enName:"pageFieldCollectionStyleSet",type:1
        },{
          cnName:"购买次数样式设置",enName:"pageFieldBuyStyleSet",type:1
        }]
      },{
        blockCnName:"tabs组件样式设置",
        filterName:'showStyle',filterValue:'6',filterType:1,
        buttonArr:[{
          cnName:"一级整体样式设置",enName:"pageFieldOneBoxStyleSet",type:1
        },{
          cnName:"一级tabs组件样式设置",enName:"pageFieldOneTabsStyleSet",type:1
        },{
          cnName:"一级tab未选中样式设置",enName:"pageFieldOneTabDefaultStyleSet",type:1
        },{
          cnName:"一级tab选中样式设置",enName:"pageFieldOneTabCheckStyleSet",type:1
        },{
          cnName:"二级整体样式设置",enName:"pageFieldTwoBoxStyleSet",type:1
        },{
          cnName:"二级tabs组件样式设置",enName:"pageFieldTwoTabsStyleSet",type:1
        },{
          cnName:"二级tab未选中样式设置",enName:"pageFieldTwoTabDefaultStyleSet",type:1
        },{
          cnName:"二级tab选中样式设置",enName:"pageFieldTwoTabCheckStyleSet",type:1
        }]
      },{
        blockCnName:"轮播样式设置",
        filterName:'showStyle',filterValue:'2',filterType:1,
        buttonArr:[{
          cnName:"轮播外层的样式设置",enName:"pageFieldRotationBoxStyleSet",type:1
        },{
          cnName:"轮播内容的样式设置",enName:"pageFieldRotationCommonStyleSet",type:1
        }]
      },{
        blockCnName:"头像样式设置",
        filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"老师字段外层样式设置",enName:"listFieldPhotoSrcStyleSet",type:1
        },{
          cnName:"有头像的老师字段样式设置",enName:"listFieldNoPhotoSrcStyleSet",type:1
        },{
          cnName:"有头像的老师头像样式设置",enName:"listFieldTeacherStyleSet",type:1
        },{
          cnName:"无头像的老师字段样式设置",enName:"listFieldPhotoSrcPhotoStyleSet",type:1
        }]
      }],
      pageFieldBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
            cnName:"字段",enName:"fieldObj",type:10,placeholder:'',filterJson:{
              mainTableId:that.tableId,
              filterType:"0!25!26!27!28"
            }
          },{
            cnName:"中文名称",enName:"fieldCnName",type:2,placeholder:'',ifMust:1
          },{
            cnName:"自定义别名",enName:"zdyAliasName",type:2,placeholder:''
          },{
            cnName:"是否必填",enName:"ifMust",type:1,
            dicList:[{label:"非必填",value:0},{label:"必填",value:1},{label:"选填",value:1}]
          },{
            cnName:"是否可修改",enName:"ifUpdate",type:1,
            dicList:[{label:"是",value:1},{label:"否",value:0}]
          },{
            cnName:"隐藏显示清值",enName:"ifChangeClean",type:1,
            dicList:[{label:"是",value:0},{label:"否",value:1}]
          },{
            cnName:"是否可新增",enName:"ifCanAdd",type:1,filterName:'fieldRole',filterValue:'20,21,22',filterType:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"添加页面",enName:"addPageId",type:14,filterName:'ifCanAdd',filterValue:'1',filterType:1,
            filterEnName:'fieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'5'
          },{
            cnName:"添加形式",enName:"addStyle",type:1,
            dicList:[{label:"选择对象添加",value:1},{label:"默认全部添加",value:2},{label:"点击+号添加",value:3}],filterName:'fieldRole',filterValue:'21',filterType:1
          },{
            cnName:"添加形式",enName:"addStyle",type:1,
            dicList:[{label:"选择对象添加",value:1},{label:"默认全部添加",value:2}],filterName:'fieldRole',filterValue:'20,22',filterType:1
          },{
            cnName:"选择形式",enName:"chooseType",type:1,
            dicList:[{label:"弹出层",value:0},{label:"下拉树",value:1},{label:"下拉框",value:2}],filterName:'fieldRole',filterValue:'20,21,22',filterType:1
          },{
            cnName:"弹出层页面",enName:"pageDialog",type:14,filterName:'chooseType',filterValue:'0,2',filterType:1,filterEnName:'fieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'15'
          },{
            cnName:"下拉树",enName:"pageDialog",type:14,filterName:'chooseType',filterValue:'1',filterType:1,filterEnName:'fieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'16'
          },{
            cnName:"前置条件",enName:"tjIdJson",type:6,placeholder:''
          },{
            cnName:"默认值",enName:"valuePlugIdJson",type:4, placeholder:''
          },{
            cnName:"字段描述",enName:"fieldDescribe",type:5,placeholder:''
          },{
            cnName:"自定义sql",enName:"customSql",type:5,placeholder:''
          },{
            cnName:"子表格页面",enName:"showFieldArr",type:16,placeholder:''
          }
        ]
      }],
      tabPageBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
          cnName:"名称",enName:"tabName",type:2,placeholder:'',ifMust:1
        },{
          cnName:"类型",enName:"type",type:1,dicList:[{label:"列表",value:1},{label:"添加",value:5},{label:"修改",value:7},{label:"查看",value:11}],ifMust:1
        },{
          cnName:"是否显示搜索条件",enName:"ifShowSearch",type:1,dicList:[{label:"是",value:0},{label:"否",value:1}],filterName:'type',filterValue:"1",filterType:1
        },{
          cnName:"是否自定义关联条件",enName:"ifZdyGl",type:1,dicList:[{label:"否",value:0},{label:"是",value:1}],filterName:'type',filterValue:"1",filterType:1
        },{
          cnName:"关联外键",enName:"fieldObj",type:10,placeholder:'',filterJson:{
            mainTableId:"mainTableId"
          },filterFieldRole:"0!20!22",filterName:'type',filterValue:"5,7,11",filterType:1
        },{
          cnName:"关联对象",enName:"relationObjIdTable",type:8,placeholder:'',
        },{
          cnName:"页面",enName:"tabPageId",type:14,placeholder:'',filterEnName:"relationObjIdTable",filterFieldEnName:"tableId",filterPageTypeEnName:"type",filterName:'relationObjIdTable',filterType:3,addPageName:"tabName",ifZdyAddPage:1
        },
        {
          cnName:"自定义关联条件",enName:"zdyChildGlSql",type:5,placeholder:'',filterName:'ifZdyGl',filterValue:"1",filterType:1
        },
        {
          cnName:"关联条件",enName:"otherPageTjIdJson",type:6,placeholder:'',filterEnName:"relationObjIdTable",filterFieldEnName:"tableId",filterName:'ifZdyGl',filterValue:"0",filterType:1
        },
        {
          cnName:"启用条件",enName:"qyTjList",type:9,placeholder:'',
          fieldArr:[{
            cnName:"名称",enName:"gl_qyTjName",type:2,placeholder:''
          },{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:''
          }]
        },
        {
          cnName:"禁用条件",enName:"jyTjList",type:9,placeholder:'',
          fieldArr:[{
            cnName:"名称",enName:"gl_jyTjName",type:2,placeholder:''
          },{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:''
          }]
        }]
      }]
    };
  },
  created() {
    this.hasLoad = false;
    if(this.initPageId > 0) {
      this.pageId = this.initPageId;
    }
    var paramsQuery = this.$route.query;
    if(paramsQuery.pageId > 0) {
      this.pageId = paramsQuery.pageId;
    }
    if(paramsQuery.sourceType > 0) {
      this.sourceType = paramsQuery.sourceType;
    }
    if(this.sourceType != 2) {
      this.aliasWidth = (window.innerWidth - 375) + "px";
    }
    this.loadPageSet();
    this.loadImageList();
  },
  mounted() {
  },
  watch:{
  },
  computed:{
  },
  components: {
    TabPageSet,
    PageBasicSet,
    CommonStyleSet,
    LookFieldSet,
    kw_list,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  methods: {
    setColValue(){
      var setBlockingPC = []
      if(this.colBlockNum*1 > 0){
        for(var i=0;i < this.colBlockNum;i++){
          var object = {width:0};
          setBlockingPC.push(object)
        }
        // this.pageInfo.styleSet.setBlockingPC = setBlockingPC;
        this.$set(this.pageInfo.styleSet,"setBlockingPC",setBlockingPC);
        console.log(this.pageInfo.styleSet.setBlockingPC,'setBlockingPCsetBlockingPCsetBlockingPCsetBlockingPC')
        this.colProportion = true
      }else{
        this.colProportion = false
        this.pageInfo.styleSet.setBlockingPC = setBlockingPC
      }
    },
    /**
     * 根据页面ID 加载页面设置信息
     */
    loadPageSet(){
      var that = this;
      //读取页面 的page对象
      var url = "/pageShowSet_loadMongoInfoById.do?source=1";
      var toHtData = {};
      toHtData.dataId = that.pageId;
      toHtData.mongoName = "page";
      toHtData.mongoIdName = "pageId";
      toHtData.sourceType = that.sourceType;
      that.loading = true;

      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.loading = false;
          if (res.data != null) {
            that.pageInfo = res.data;
            if(!that.pageInfo.styleSet) {
              var initStyleSet = {};
              that.$set(that.pageInfo,"styleSet",initStyleSet);
            }
            if(that.pageInfo.styleSet.setBlockingPC){
              if (that.pageInfo.styleSet.setBlockingPC.length > 0) {
                that.colBlockNum = that.pageInfo.styleSet.setBlockingPC.length
                that.colProportion = true
              }
            }
          }
          
          if(!that.pageInfo.listStyleSet) {
            that.$set(that.pageInfo,"listStyleSet",{});
          }
          //如果是添加修改页面 生成按钮组 保存按钮和取消按钮
          if(!that.pageInfo.styleSet.updateButtonSet) {
            var updateButtonSet = [ 
              {
                buttonName:"保存",
                buttonType:20
              },{
                buttonName:"取消",
                buttonType:21
              }
            ]
            that.$set(that.pageInfo.styleSet,"updateButtonSet",updateButtonSet);
          }
          that.initStyleSetByBack();
          var pcH5Type = false;
          for (var key in that.pageInfo) {
            if(key.endsWith("tyleSetPC")) {
              pcH5Type = true;
            }
          }
          that.pcH5Type = pcH5Type;

          // that.initPreviewPageDataInfo();
          // if(that.pageInfo.styleSet.oldToNew!=1) {
            // that.initNewStyleByOld();
          // }
          that.hasLoad = true;
        },
        fail: function () {
          that.loading = false;
          console.log("服务器异常!",error);
        }
      });
    },
    /**
     * 根据页面ID 加载页面设置信息
     */
    loadImageList(){
      var that = this;
      //读取页面 的page对象
      var url = "/model_getSqlResult.do?source=1";
      var toHtData = {};
      //分页信息 
      // toHtData.start = 0;
      // toHtData.limit = 1000 + "_flow";
      // //tableId 表id
      // toHtData.tableId = 36;
      // //pageId 页面id
      // toHtData.pageId = 61;
      toHtData.sql = "SELECT IMAGE_NAME NAME,FILES.F_MONGOID BG_URL,KW_IMAGE.ZD_TYPE TYPE FROM KW_IMAGE LEFT JOIN FILES ON FILES.F_ID = KW_IMAGE.IMAGE_URL";
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.ImageList = res.data;
        },
        fail: function () {
          console.log("error=====" + error);
        }
      });
    },
    /**
     * 打开字段设置页面
     */
    openDialog(type,index){
      this.nowFieldIndex = index;
      this.addDialogType = type;
      if(type == 1) {
        // 搜索条件设置
        if(!this.pageInfo.searchStyleSet) {
          this.$set(this.pageInfo,"searchStyleSet",{});
        }
      } else if(type == 2){
        // 添加修改查看页面的字段设置
        // if(!this.pageInfo.addFieldSet[index].styleSet) {
        //   this.$set(this.pageInfo.addFieldSet[index],"styleSet",{});
        // }
        console.log("this.pageInfo.addFieldSet[index].styleSet===============",this.pageInfo.addFieldSet[index].styleSet);
      } else if(type == 3){
        // 选项卡设置
        if(!this.pageInfo.tabPageSet[index].styleSet) {
          this.$set(this.pageInfo.tabPageSet[index],"styleSet",{});
        }
      } else if(type == 4){
        // 列表页面设置
        if(!this.pageInfo.listStyleSet) {
          this.$set(this.pageInfo,"listStyleSet",{});
        }
      } else if(type == 5) {
        // 打开关联页面的设置页面
        var pageId = this.pageInfo.tabPageSet[index].tabPageId;
        console.log("pageId=========================",pageId);
        var { href } = this.$router.resolve({
          path: "pageShowSet",
          query: {
            pageId: pageId,
            sourceType:this.sourceType
          }
        });
        href = "pageShowSet?pageId="+pageId+"&sourceType="+this.sourceType;
        window.open(href, "_blank");
        return;
      } else if(type == 6){
        // 搜索条件字段设置
        if(!this.pageInfo.searchSet[index].styleSet) {
          this.$set(this.pageInfo.searchSet[index],"styleSet",{});
        }
      } else if(type == 7) {
        //列表数据操作按钮设置
        if(!this.pageInfo.operaButtonSet[index].styleSet) {
          this.$set(this.pageInfo.operaButtonSet[index],"styleSet",{});
        }
      } else if(type == 770) {
        // 按钮整体样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.operaButtonSetAll) {
          this.$set(this.pageInfo.styleSet,"operaButtonSetAll",{"ImageType":1});
        }
		  } else if(type == 771) {
        // 按钮整体样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.updateButtonSetAll) {
          this.$set(this.pageInfo.styleSet,"updateButtonSetAll",{"ImageType":1});
        }
      }else if(type == 8) {
        //列表字段设置
        if(!this.pageInfo.fieldSet[index].styleSet) {
          this.$set(this.pageInfo.fieldSet[index],"styleSet",{});
        }
      } else if(type == 9) {
        //添加修改 保存操作按钮设置
      } else if(type == 10) {
        //搜索条件字段设置(动态搜索条件)
        if(!this.pageInfo.dynamicSearchSet[index].styleSet) {
          this.$set(this.pageInfo.dynamicSearchSet[index],"styleSet",{});
        }
      } else if(type == 11) {
        //列表操作操作(按钮条)按钮设置
        if(!this.pageInfo.buttonSet[index].styleSet) {
          this.$set(this.pageInfo.buttonSet[index],"styleSet",{});
        }
      } else if(type == 12) {
        //查看修改添加页面的字段打开子页面的设置信息
        var pageId = this.pageInfo.addFieldSet[index].showFieldArr;
        var href = "pageShowSet?pageId="+pageId+"&sourceType="+this.sourceType;;
        window.open(href, "_blank");
        return;
      }else if(type == 27) {
        // 查看页面整体样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookCommonRowBoxStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookCommonRowBoxStyleSet",{"ImageType":1});
        }
        
      }else if(type == 13) {
        // 查看页面整体样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 14) {
        // 搜索条件样式设置 会拼接为style 
        if(!this.pageInfo.searchStyleSet.searchCommonStyleSet) {
          this.$set(this.pageInfo.searchStyleSet,"searchCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 15) {
        // 查看页面字段整体样式设置(样式类型外样式) 会拼接为style 
        if(!this.pageInfo.addFieldSet[index].lookFieldCommonStyleSet) {
          this.$set(this.pageInfo.addFieldSet[index],"lookFieldCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 16) {
        // 查看页面 平铺选项卡样式 会拼接为style 
        if(!this.pageInfo.styleSet.lookTileTabsCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTileTabsCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 17) {
        // 查看页面 选项卡名称样式 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabTitleCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabTitleCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 18) {
        // 查看页面 选项卡更多样式 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabMoreCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabMoreCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 19) {
        // 查看页面 选项卡整体样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabsBoxCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabsBoxCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 20) {
        // 查看页面 选项卡tabs组件样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabsCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabsCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 21) {
        // 查看页面 选项卡tab未选中样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabDefaultCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabDefaultCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 22) {
        // 查看页面 选项卡tab选中样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabCheckCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabCheckCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 23) {
        if(!this.pageInfo.tabPageSet[index].styleSet) {
           this.$set(this.pageInfo.tabPageSet[index],"styleSet",{});
        }
        // 查看页面 子选项卡tab未选中样式设置 会拼接为style 
        if(!this.pageInfo.tabPageSet[index].styleSet.lookTabChildDefaultCommonStyleSet) {
          this.$set(this.pageInfo.tabPageSet[index].styleSet,"lookTabChildDefaultCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 24) {
        if(!this.pageInfo.tabPageSet[index].styleSet) {
           this.$set(this.pageInfo.tabPageSet[index],"styleSet",{});
        }
        // 查看页面 子选项卡tab选中样式设置 会拼接为style 
        if(!this.pageInfo.tabPageSet[index].styleSet.lookTabChildCheckCommonStyleSet) {
          this.$set(this.pageInfo.tabPageSet[index].styleSet,"lookTabChildCheckCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 25) {
        // 查看页面 子选项卡tab选中样式设置 会拼接为style 
        if(!this.pageInfo.listStyleSet.listBgImageCommonStyleSet) {
          this.$set(this.pageInfo.listStyleSet,"listBgImageCommonStyleSet",{"ImageType":1});
        }
      } else if(type == 26) {
        if(!this.pageInfo.styleSet.pageBoxStyleSet) {
          this.$set(this.pageInfo.styleSet,"pageBoxStyleSet",{"ImageType":1});
        }
      } else if(type == 28) {
        // 查看页面 选项卡tab组件样式设置 会拼接为style 
        if(!this.pageInfo.styleSet.lookTabCommonStyleSet) {
          this.$set(this.pageInfo.styleSet,"lookTabCommonStyleSet",{"ImageType":1});
        }
        
      }
      this.addDialogFlag = true;
    },
    /**
     * 保存数据
     */
    saveInfo(){
      var that = this;
      var url = "/pageShowSet_saveMongoInfoById.do?source=1";
      var dataId = this.pageId;
      var toHtData = {};
      toHtData.dataId = dataId;
      toHtData.mongoName = "page";
      toHtData.mongoIdName = "pageId";
      toHtData.sourceType = that.sourceType;
      //进行vue新增设置的 另外保存设置 放置出现丢失的情况
      this.backStyleSet();
      toHtData.jsonStr = JSON.stringify(that.pageInfo);
      this.fullscreenLoading = true;
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.fullscreenLoading = false;
          if(res.data > 0) {
            that.$message({
              showClose: true,
              message: "保存成功!",
              type: 'success'
            });
          } else {
            that.$message({
              showClose: true,
              message: "保存失败,请重试!",
              type: 'error'
            });
          }
        },
        fail: function () {
          console.log("error=====" + error);
        }
      });
    },
    /**
     * 进行样式设置备份
     */
    backStyleSet(){
      var pageInfo = this.pageInfo;
      // 添加修改查看页面的字段设置
      this.backOne(pageInfo,"addFieldSet","fieldId","valuePlugId");
      // 打开关联页面的设置页面
      this.backOne(pageInfo,"tabPageSet","tabPageId",null);
      // 搜索条件字段设置
      this.backOne(pageInfo,"searchSet","fieldId","valuePlugId");
      // 列表数据操作按钮设置
      this.backOne(pageInfo,"operaButtonSet","buttonPageId",null);
      // 列表字段设置
      this.backOne(pageInfo,"fieldSet","fieldId","valuePlugId");
      // 列表操作操作(按钮条)按钮设置
      this.backOne(pageInfo,"buttonSet","buttonPageId",null);
    },
    /**
     * 备份其中一个元素
     */
    backOne(pageInfo,backName,fieldName1,fieldName2){
      var one_back = {};
      if(pageInfo[backName]) {
        pageInfo[backName].forEach(element => {
          var fieldId1 = element[fieldName1];
          var tmpId = fieldId1;
          if(fieldName2 != null) {
            var fieldId2 = element[fieldName2];
            if(fieldId2 > 0) {
              tmpId = fieldId2;
            }
          }
          one_back["field_"+tmpId] = element.styleSet;
        });
      }
      pageInfo[backName+'_back'] = one_back;
    },
    /**
     * 初始化页面设置 通过保存的备份信息
     */
    initStyleSetByBack(){
      var pageInfo = this.pageInfo;
      // 添加修改查看页面的字段设置
      this.initStyleSetOneByBack(pageInfo,"addFieldSet","fieldId","valuePlugId");
      // 打开关联页面的设置页面
      this.initStyleSetOneByBack(pageInfo,"tabPageSet","tabPageId",null);
      // 搜索条件字段设置
      this.initStyleSetOneByBack(pageInfo,"searchSet","fieldId","valuePlugId");
      // 列表数据操作按钮设置
      this.initStyleSetOneByBack(pageInfo,"operaButtonSet","buttonPageId",null);
      // 列表字段设置
      this.initStyleSetOneByBack(pageInfo,"fieldSet","fieldId","valuePlugId");
      // 列表操作操作(按钮条)按钮设置
      this.initStyleSetOneByBack(pageInfo,"buttonSet","buttonPageId",null);
      if(pageInfo.tabPageSet) {
        pageInfo.tabPageSet.forEach(element => {
          if(!element.styleSet) {
            this.$set(element,"styleSet",{});
          }
          if(element.lookTabChildDefaultCommonStyleSet) {
            this.$set(element.styleSet,"lookTabChildDefaultCommonStyleSet",element.lookTabChildDefaultCommonStyleSet);
          }
          if(element.lookTabChildCheckCommonStyleSet) {
            this.$set(element.styleSet,"lookTabChildCheckCommonStyleSet",element.lookTabChildCheckCommonStyleSet);
          }
        });
      }
      this.pageInfo = pageInfo;
    },
    /**
     * 初始化页面设置 通过保存的备份信息
     */
    initStyleSetOneByBack(pageInfo,backName,fieldName1,fieldName2){
      if(pageInfo[backName]) {
        var backOne = pageInfo[backName+'_back'];
        pageInfo[backName].forEach(element => {
          var fieldId1 = element[fieldName1];
          var tmpId = fieldId1;
          if(fieldName2 != null) {
            var fieldId2 = element[fieldName2];
            if(fieldId2 > 0) {
              tmpId = fieldId2;
            }
          }
          if(!element.styleSet) {
            if(backOne && backOne["field_"+tmpId]) {
              // element.styleSet = pageInfo[backName+'_back']["field_"+tmpId];
              this.$set(element,"styleSet",pageInfo[backName+'_back']["field_"+tmpId]);
            } else {
              // element.styleSet = {};
              this.$set(element,"styleSet",{});
            }
          }
        });
      }
    },
    /**
     * 关闭页面
     */
    cancelPage(){

    },
    /**
     * 制作预览页面的数据
     */
    initPreviewPageDataInfo() {
      var that = this;
      var pageInfo = that.pageInfo;
      if(pageInfo.pageType == 1 || pageInfo.pageType == 15) {
        var previewPageDataInfo = [];
        // 循环显示列的字段 进行数据组合
        previewPageDataInfo.push(that.initPreviewPageDataOneInfo(1));
        previewPageDataInfo.push(that.initPreviewPageDataOneInfo(2));
        that.previewPageDataInfo = previewPageDataInfo;
      } else {
        var previewPageDataInfo = that.initPreviewPageDataOneInfo(1);

        that.previewPageDataInfo = previewPageDataInfo;
      }
    },
    initPreviewPageDataOneInfo(dataIndex) {
      var that = this;
      var pageInfo = this.pageInfo;
      var dataInfo = {
        "LMF_ID":dataIndex
      };
      dataInfo["T_" + pageInfo.tableId + "_0"] = dataIndex;
      var fieldSet = pageInfo.fieldSet?pageInfo.fieldSet:pageInfo.addFieldSet;
      for (let index = 0; index < fieldSet.length; index++) {
        const fieldOne = fieldSet[index];
        if(index == 0) {
          dataInfo[fieldOne.fieldAliasName] = fieldOne.fieldCnName + "_" + dataIndex
        } else {
          dataInfo[fieldOne.fieldAliasName] = index
        }
      }
      return dataInfo;
    },
    //字段位置上移
    toUpChildOne(fieldList,index) {
      if(index == 0) {
        var tmpOne = fieldList.splice(index,1);
        fieldList.push(tmpOne[0]);
      } else {
        var targetIndex = index-1;
        fieldList[index] = fieldList.splice(targetIndex, 1, fieldList[index])[0];
      }
      this.$forceUpdate();
    },
    /**
     * 字段位置下移
     */
    toDownChildOne(fieldList,index){
      if(index+1 == fieldList.length) {
        var tmpOne = fieldList.splice(index,1);
        fieldList.unshift(tmpOne[0]);
      } else {
        var targetIndex = index+1;
        fieldList[index] = fieldList.splice(targetIndex, 1, fieldList[index])[0];
      }
      this.$forceUpdate();
    },
    /**
     * 删除字段
     */
    toDeleteChildOne(fieldList,index){
      fieldList.splice(index,1);
      this.$forceUpdate();
    },
    /**
     * 添加列表字段
     */
    addListField() {
      var that = this;
      var basicBlockArr = that.listFieldBasicBlockArr;
      var newFieldJson = {fieldId:0,styleSet:{}};
      basicBlockArr[0].fieldArr.forEach(element=>{
        if(element.type == 2) {
          newFieldJson[element.enName] = "";
        } else if(element.type == 4 || element.type == 17) {
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          };
        } else if(element.type == 6){
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            tjPlugId:0
          };
        } else {
          newFieldJson[element.enName] = null;
        }
      })
      console.log("newFieldJson========================",newFieldJson);
      if(!that.pageInfo.fieldSet) {
        that.$set(that.pageInfo,"fieldSet",[]);
      }
      that.pageInfo.fieldSet.push(newFieldJson);
    },
    /**
     * 添加搜索条件字段
     */
    addSearchField(){
      var that = this;
      var newFieldJson = {fieldId:0,styleSet:{}};
      var basicBlockArr = that.searchFieldBasicBlockArr;
      basicBlockArr[0].fieldArr.forEach(element=>{
        if(element.type == 2) {
          newFieldJson[element.enName] = "";
        } else if(element.type == 4 || element.type == 17) {
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          };
        } else if(element.type == 6){
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            tjPlugId:0
          };
        } else {
          newFieldJson[element.enName] = null;
        }
      })
      console.log("newFieldJson========================",newFieldJson);
      if(!that.pageInfo.searchSet) {
        that.$set(that.pageInfo,"searchSet",[]);
      }
      that.pageInfo.searchSet.push(newFieldJson);
    },
    deleteAllSearchField() {
      this.pageInfo.searchSet = [];
    },
    deleteAllListField() {
      this.pageInfo.fieldSet = [];
    },
    //添加一个新按钮
    addOperaButtonSet(type){
      var that = this;
      var basicBlockArr = that.buttonBasicBlockArr;
      var newFieldJson = {fieldId:0,styleSet:{}};
      basicBlockArr[0].fieldArr.forEach(element=>{
        if(element.type == 2) {
          newFieldJson[element.enName] = "";
        } else if(element.type == 4 || element.type == 17) {
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          };
        } else if(element.type == 6){
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            tjPlugId:0
          };
        } else {
          newFieldJson[element.enName] = null;
        }
      })
      console.log("newFieldJson========================",newFieldJson);
      if(type == 1) {
        if(!that.pageInfo.operaButtonSet) {
          that.$set(that.pageInfo,"operaButtonSet",[]);
        }
        that.pageInfo.operaButtonSet.push(newFieldJson);
      } else {
        if(!that.pageInfo.buttonSet) {
          that.$set(that.pageInfo,"buttonSet",[]);
        }
        that.pageInfo.buttonSet.push(newFieldJson);
      }
    },
    addTabPageSet(){
      var that = this;
      var newFieldJson = {};
      var basicBlockArr = that.tabPageBasicBlockArr;
      basicBlockArr[0].fieldArr.forEach(element=>{
        if(element.type == 2) {
          newFieldJson[element.enName] = "";
        } else if(element.type == 4 || element.type == 17) {
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          };
        } else if(element.type == 6){
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            tjPlugId:0
          };
        } else {
          newFieldJson[element.enName] = null;
        }
      })
      console.log("newFieldJson========================",newFieldJson);
      if(!that.pageInfo.tabPageSet) {
        that.$set(that.pageInfo,"tabPageSet",[]);
      }
      that.pageInfo.tabPageSet.push(newFieldJson);
    },
    handleClose(done){
      var that = this;
      var mustFlag = true;
      var message = "";
      //字段基础设置
      var value = null;
      var blockArr = null;
      if(that.addDialogType==32) {
        value = that.pageInfo.operaButtonSet[that.nowFieldIndex];
        blockArr = that.buttonBasicBlockArr;
      } else if(that.addDialogType==31) {
        value = that.pageInfo.buttonSet[that.nowFieldIndex];
        blockArr = that.buttonBasicBlockArr;
      }
      if(value != null && blockArr != null) {
        blockArr.forEach(blockOne=>{
          blockOne.fieldArr.forEach(fieldOne=>{
            if(fieldOne.ifMust == 1 && ((!fieldOne.filterName || (fieldOne.filterType==1 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')>=0) || (fieldOne.filterType==2 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')==-1) || (fieldOne.filterType==3 && value[fieldOne.filterName])))){
              console.log("that.value[fieldOne.enName]====================",fieldOne.cnName,fieldOne,value,value[fieldOne.enName],(!value[fieldOne.enName]),typeof(value[fieldOne.enName]));
              if(value[fieldOne.enName] || (typeof(value[fieldOne.enName])=="number" && value[fieldOne.enName] >= 0)) {
              } else {
                mustFlag = false;
                message+=(message!=""?",":"")+fieldOne.cnName
              }
            }
          })
        })
      }
      if(mustFlag) {
        done();
      } else {
        alert("请填写必填项:"+message);
      }
    },


  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-col{min-height: 41px;padding: 3px}
  .pcPreviewBox {
    border:1px solid;
  }
  .h5PreviewBox {
    border:1px solid;
  }
</style>
